import $ from "../libs/jquery-3.5.1.min.js";
import "../libs/css_browser_selector.js";
import {Anim} from "./Anim.js";
import A from "../libs/aladin/aladin.js";

import DataTable from 'datatables.net-dt';

require('datatables.net-buttons');
require('datatables.net-buttons/js/buttons.colVis.js')
require('datatables.net-buttons/js/buttons.html5.js')
require('datatables.net-buttons/js/buttons.print.js')

let table;

export class MainApp {

  constructor() {

    this.anim = new Anim()
    this.anim.attach();
    this.plotlyLoader = null;
    this.threeLoader = null;
    this.associationCmdRows = [];
    this.associationXyzRows = [];
    this.associationXyzScene = null;
    this.associationUvwRows = [];
    this.associationUvwScene = null;
    this.autocompleteMinChars = {
      association: 2,
      publication: 2,
      star: 4,
    };

    $(window).off("resize").on("resize", $.proxy(function () {
      this.resize();
    }, this));

    this.attachSearchAutocomplete();

    $("#search-results-wrapper .results").each($.proxy(function (i, n) {
      const searchType = $(n).data("type");
      const searchQuery = String($(n).attr("data-query") || "");
      const prefetchedRequest = this.takeSearchPrefetch(searchType, searchQuery);
      const reportRequest = prefetchedRequest
        ? this.prefetchedApiRequest(prefetchedRequest, "#search-results-wrapper", this.buildResultsPage)
        : this.apiRequest("/api/search", "#search-results-wrapper", this.buildResultsPage, {
          "search-type": searchType,
          "search-query": searchQuery,
        });

      reportRequest.then((data) => {
        const results = Array.isArray(data) ? data : [];

        // Find moca_aid
        const moca_aid_field = this.findReportField(results, "moca_aid: ");
        const mocaAid = String(moca_aid_field?.value || "").trim();

        // Load figures using aid
        if (this.isValidAssociationAid(mocaAid)) {
          this.loadAssociationUvFigure(mocaAid);

          if (searchType == "association") {
            this.showAssociationExports(mocaAid);
            this.showAssociationSearchWidgets();
            this.loadAssociationCmd(mocaAid);
            this.loadAssociationXyz(mocaAid);
            this.loadAssociationUvw(mocaAid);
          }
        } else if (searchType == "association") {
          this.hideAssociationExports();
          this.hideAssociationSearchWidgets();
          this.hideAssociationUvFigure();
        }

        if (searchType == "star") {
          if (this.isReportChooser(results)) {
            this.hideObjectCmd();
            this.hideObjectExports();
          } else {
            const objectTarget = this.objectCmdTargetFromReport(results, $(n).data("query"));
            if (this.isValidObjectOid(objectTarget.mocaOid)) {
              this.showObjectExports(objectTarget.mocaOid);
            } else {
              this.hideObjectExports();
            }
            this.loadObjectCmd(results, $(n).data("query"));
          }

          // Find location
          const moca_ra_deg = this.findReportField(results, "R.A. (deg) : ")?.value;
          const moca_decl_deg = this.findReportField(results, "Decl. (deg) : ")?.value;

          if (moca_ra_deg && moca_decl_deg) {
            this.initObjectFinderCharts(moca_ra_deg, moca_decl_deg);
          } else {
            this.hideObjectFinderCharts();
          }
        }
      })
    }, this));

    $("#db-schema-wrapper .results").each($.proxy(function (i, n) {
      this.apiRequest("/api/schema", "#db-schema-wrapper", this.buildResultsPage, {
        "table": $(n).data("table")
      })
    }, this));

    $("#publication-report-wrapper .results").each($.proxy(function (i, n) {
      const mocaPid = String($(n).attr("data-moca-pid") || "").trim();
      if (mocaPid == "") return;

      this.apiRequest("/api/publication-report", "#publication-report-wrapper", this.buildPublicationReport, {
        "moca-pid": mocaPid,
      });
    }, this));

    $("#associations-wrapper .results").each($.proxy(function (i, n) {
      this.apiRequest("/api/associations", "#associations-wrapper", this.buildResultsPage)
    }, this));

    $("#overview .results").each($.proxy(function (i, n) {
      const url = $(n).data("image-endpoint");
      const wrapperSelector = "#" + $(n).parent().attr("id")
      this.apiRequest(url, wrapperSelector, (data, destination) => {
        $(destination).append(`<div class="image-wrapper"><img src='${data.url}/download'></div>`)
      }, {}, "get")
    }, this));

    if ($("#overview").length > 0) {
      this.apiRequest("/api/query", null, (data, destination) => {
        $("#overview .placeholder").each((i, n) => {
          const targetField = $(n).data("placeholder-for");
          const value = (data[0]) ? data[0][targetField] : null;
          if (value) $(n).html(value)
        });
      }, {
        "query": "SELECT " +
          "(SELECT FORMAT(COUNT(*),0) AS num_asso FROM moca_associations WHERE suboptimal_grouping=0 AND is_real != 0) as num_asso," +
          "(SELECT FORMAT(COUNT(*),0) AS age_count FROM data_association_ages) AS age_count," +
          "(SELECT FORMAT(COUNT(*),0) AS num_object FROM moca_objects) as num_object," +
          "(SELECT FORMAT(COUNT(DISTINCT moca_oid),0) AS num_l0 FROM data_spectral_types cspt WHERE cspt.adopted=1 AND cspt.spectral_type_number >= 10 AND cspt.photometric_estimate=0) AS num_l0,"+
          "(SELECT FORMAT(COUNT(DISTINCT moca_oid),0) AS num_bd FROM data_spectral_types cspt WHERE cspt.adopted=1 AND cspt.photometric_estimate=0 AND ((cspt.spectral_type_number >= 10) OR (cspt.spectral_type_number >= 6 AND (cspt.gravity_class REGEXP 'INT|VL|β|γ|δ' OR cspt.suffix REGEXP 'red|young')))) AS num_bd,"+
          "(SELECT FORMAT(COUNT(DISTINCT moca_oid),0) AS num_members FROM data_memberships dm WHERE dm.moca_mtid != 'R') AS num_members",
        "offset": 0,
        "limit": 10,
      }, "post")
    }

    $("#moca-disk-space .results").each($.proxy(function (i, n) {
      this.apiRequest("/api/disk", "#moca-disk-space", (data, destination) => {
        const usagePercentage = (data.usage * 100).toFixed(2) + "%";
        // console.log(data)
        destination.append("<div class='usage-percentage'>Disk usage: " + usagePercentage + "</div>")
        destination.append("<div class='usage-free'>Free space: " + parseFloat(data.free_gb).toFixed(2) + " GB</div>")
        destination.append("<div class='note'>Don't forget that free disk space is required for the automated backup tasks.</div>")
      }, {}, 'get')
    }, this));

    $("#db-query form").submit($.proxy(function (e) {
      e.preventDefault();
      $("#results-table-wrapper").css("opacity", 0.3);
      var url = $(e.currentTarget).attr("action");
      this.apiRequest(url, "#db-query", this.buildQueryResultsTable, {
        "offset": $("#offset", e.currentTarget).val(),
        "limit": $("#limit", e.currentTarget).val(),
        "query": $("#query", e.currentTarget).val(),
      })
    }, this));

    if ($("#db-query form").length > 0) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      if (urlSearchParams.has("query")) {
        $("#db-query form #query").val(urlSearchParams.get("query"));
        $("#db-query form").submit();
      }
    }
  }

  attachSearchAutocomplete() {
    const forms = $("form.report-search-form");
    if (forms.length == 0) return;

    $(document).off("mousedown.mocaAutocomplete").on("mousedown.mocaAutocomplete", (event) => {
      if ($(event.target).closest(".report-search-form").length == 0) {
        this.hideSearchAutocomplete();
      }
    });

    forms.each((formIndex, form) => {
      const $form = $(form);
      const $field = $(".search-field", $form);
      const $input = $("input[name='search-query']", $form);
      const $typeInput = $("input[name='search-type']", $form);
      const formSearchType = String($typeInput.val() || "").trim();
      const searchType = ["association", "publication", "star"].indexOf(formSearchType) != -1
        ? formSearchType
        : "association";
      const minChars = this.autocompleteMinChars[searchType] || this.autocompleteMinChars.star;
      const panelId = `search-autocomplete-${formIndex}-${searchType}`;
      const $panel = $("<div class='search-autocomplete-panel' role='listbox' hidden></div>").attr("id", panelId);
      const $spinner = $("<span class='search-live-spinner' aria-hidden='true' hidden></span>");
      let requests = [];
      let timer = null;
      let activeIndex = -1;
      let suggestions = [];
      let availableSuggestions = [];

      if ($field.length == 0 || $input.length == 0) return;

      $field.append($panel);
      $field.append($spinner);
      $input.attr({
        "autocomplete": "off",
        "aria-autocomplete": "list",
        "aria-expanded": "false",
        "aria-controls": panelId,
        "role": "combobox",
      });

      const updateLoadingIndicator = () => {
        if (requests.length > 0) {
          $spinner.removeAttr("hidden");
        } else {
          $spinner.attr("hidden", true);
        }
      };

      const abortRequests = () => {
        requests.forEach((request) => request.abort());
        requests = [];
        updateLoadingIndicator();
      };

      const forgetRequest = (request) => {
        requests = requests.filter((activeRequest) => activeRequest !== request);
        updateLoadingIndicator();
      };

      const hide = () => {
        activeIndex = -1;
        suggestions = [];
        availableSuggestions = [];
        $panel.empty().attr("hidden", true);
        $input.attr("aria-expanded", "false").removeAttr("aria-activedescendant");
      };

      const setActive = (index) => {
        const options = $(".search-autocomplete-option", $panel);
        if (options.length == 0) return;

        activeIndex = (index + options.length) % options.length;
        options.removeClass("is-active").attr("aria-selected", "false");

        const activeOption = options.eq(activeIndex);
        activeOption.addClass("is-active").attr("aria-selected", "true");
        $input.attr("aria-activedescendant", activeOption.attr("id"));
      };

      const submitSuggestion = (suggestion) => {
        const canonicalId = (searchType == "association" || searchType == "publication")
          ? String(suggestion?.id || "").trim()
          : "";
        const value = canonicalId || suggestion?.value || suggestion?.label || "";
        if (value == "") return;

        $input.val(value);
        hide();

        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          form.submit();
        }
      };

      const suggestionIdentityKey = (suggestion) => {
        const type = suggestion?.type || searchType;
        const id = String(suggestion?.id || "").trim();
        if (id != "") return [type, id].join("|");

        return [
          type,
          suggestion?.value || "",
          suggestion?.label || "",
        ].join("|");
      };

      const deduplicateSuggestions = (items) => {
        const merged = [];
        const seen = new Set();

        (Array.isArray(items) ? items : []).forEach((suggestion) => {
          const key = suggestionIdentityKey(suggestion);

          if (!seen.has(key)) {
            seen.add(key);
            merged.push(suggestion);
          }
        });

        return merged;
      };

      const mergeSuggestions = (baseItems, extraItems) => {
        const base = Array.isArray(baseItems) ? baseItems : [];
        const extra = Array.isArray(extraItems) ? extraItems : [];
        return deduplicateSuggestions([...base, ...extra]);
      };

      const autocompleteFilterPattern = (query) => {
        const escaped = String(query || "").trim().replace(/\s+/g, " ")
          .replace(/[.+?^${}()|[\]\\]/g, "\\$&")
          .replace(/%/g, ".*");

        return escaped ? new RegExp(escaped, "i") : null;
      };

      const filterAvailableSuggestions = (query) => {
        const pattern = autocompleteFilterPattern(query);
        if (pattern == null) return [];

        return availableSuggestions.filter((suggestion) => {
          const text = [
            suggestion?.label || "",
            suggestion?.value || "",
            suggestion?.detail || "",
            suggestion?.title || "",
          ].join(" ");

          return pattern.test(text);
        });
      };

      const renderSuggestions = (items, options = {}) => {
        const incomingSuggestions = deduplicateSuggestions(items);
        const nextSuggestions = options.append
          ? mergeSuggestions(availableSuggestions, incomingSuggestions)
          : incomingSuggestions;
        activeIndex = -1;
        $panel.empty();

        if (nextSuggestions.length == 0) {
          if (options.preserveExisting && suggestions.length > 0) {
            renderSuggestions(suggestions);
            return;
          }

          hide();
          return;
        }

        if (!options.transient) {
          availableSuggestions = nextSuggestions;
        }
        suggestions = nextSuggestions;
        suggestions.forEach((suggestion, index) => {
          const optionId = `${panelId}-option-${index}`;
          const label = suggestion.label || suggestion.value || "";
          const detail = suggestion.detail || "";
          const title = suggestion.title || "";
          const button = $("<button class='search-autocomplete-option' type='button' role='option'></button>")
            .attr("id", optionId)
            .attr("aria-selected", "false")
            .append(`<span class="search-autocomplete-label">${this.escapeHtml(label)}</span>`);

          if (detail) {
            button.append(`<span class="search-autocomplete-detail">${this.escapeHtml(detail)}</span>`);
          }

          if (title) {
            button.append(`<span class="search-autocomplete-title">${this.escapeHtml(title)}</span>`);
          }

          button.on("mousedown", (event) => event.preventDefault());
          button.on("click", () => submitSuggestion(suggestion));
          $panel.append(button);
        });

        $panel.removeAttr("hidden");
        $input.attr("aria-expanded", "true");
      };

      const loadSuggestions = () => {
        const query = String($input.val() || "").trim().replace(/\s+/g, " ");

        if (timer) window.clearTimeout(timer);

        if (query.length < minChars) {
          abortRequests();
          hide();
          return;
        }

        if ((searchType == "star" || searchType == "publication") && availableSuggestions.length > 0) {
          const filteredSuggestions = filterAvailableSuggestions(query);
          if (filteredSuggestions.length > 0) {
            renderSuggestions(filteredSuggestions, {transient: true});
          }
        }

        timer = window.setTimeout(() => {
          abortRequests();

          const currentQuery = query;
          const renderIfCurrent = (data, options) => {
            const latestQuery = String($input.val() || "").trim().replace(/\s+/g, " ");
            if (latestQuery != currentQuery) return;

            renderSuggestions(data?.suggestions || [], options);
          };

          const requestSuggestions = (source, options) => {
            const xhr = $.ajax({
              dataType: "json",
              method: "get",
              url: "/api/autocomplete",
              data: {
                "type": searchType,
                "source": source,
                "q": currentQuery,
              },
              success: (data) => renderIfCurrent(data, options),
              error: () => {
                if (!options.preserveExisting) hide();
              },
              complete: () => forgetRequest(xhr),
            });

            requests.push(xhr);
            updateLoadingIndicator();
            return xhr;
          };

          if (searchType == "star") {
            requestSuggestions("primary", {append: false}).always(() => {
              const latestQuery = String($input.val() || "").trim().replace(/\s+/g, " ");
              if (latestQuery == currentQuery) {
                requestSuggestions("expanded", {append: true, preserveExisting: true});
              }
            });
            return;
          }

          requestSuggestions("expanded", {append: false});
        }, 220);
      };

      $input.on("input", loadSuggestions);
      $input.on("focus", loadSuggestions);
      $input.on("blur", () => window.setTimeout(hide, 150));
      $input.on("keydown", (event) => {
        if ($panel.attr("hidden")) return;

        if (event.key == "ArrowDown") {
          event.preventDefault();
          setActive(activeIndex + 1);
        } else if (event.key == "ArrowUp") {
          event.preventDefault();
          setActive(activeIndex - 1);
        } else if (event.key == "Enter" && activeIndex >= 0) {
          event.preventDefault();
          submitSuggestion(suggestions[activeIndex]);
        } else if (event.key == "Escape") {
          hide();
        }
      });
    });
  }

  hideSearchAutocomplete() {
    $(".search-autocomplete-panel").empty().attr("hidden", true);
    $(".report-search-form input[name='search-query']")
      .attr("aria-expanded", "false")
      .removeAttr("aria-activedescendant");
  }

  resize() {
    this.updateReportPaneHeight();
    this.updateObjectCmdTargetOverlayForCurrentPlot();
  }

  updateReportPaneHeight() {
    const row = $(".report-scroll-row");
    if (row.length == 0) return;

    if (!window.matchMedia("(min-width: 768px)").matches) {
      row.css("--report-pane-height", "");
      return;
    }

    const rowTop = row.get(0).getBoundingClientRect().top;
    const height = Math.max(360, window.innerHeight - rowTop);

    row.css("--report-pane-height", `${height}px`);
  }

  findReportField(data, label) {
    const tables = Array.isArray(data) ? data : [];
    for (const table of tables) {
      const row = Array.isArray(table?.data)
        ? table.data.find((el) => el.label === label)
        : null;
      if (row) return row;
    }
    return null;
  }

  findReportFieldByLabelText(data, labels) {
    const tables = Array.isArray(data) ? data : [];
    const labelKeys = (Array.isArray(labels) ? labels : [labels])
      .map((label) => this.reportTextForDetection(label).replace(/:+$/g, ""));

    for (const table of tables) {
      const rows = Array.isArray(table?.data) ? table.data : [];
      for (const row of rows) {
        const key = this.reportTextForDetection(row?.label).replace(/:+$/g, "");
        if (labelKeys.some((labelKey) => key == labelKey || key.includes(labelKey))) {
          return row;
        }
      }
    }

    return null;
  }

  reportPlainText(value) {
    return String(value || "")
      .replace(/<br\s*\/?>/gi, " ")
      .replace(/<[^>]*>/g, " ")
      .replace(/&nbsp;/gi, " ")
      .replace(/&amp;/gi, "&")
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .replace(/\s+/g, " ")
      .trim();
  }

  reportOptionalText(value) {
    const text = this.reportPlainText(value);
    return /^(null|undefined|not set)$/i.test(text) ? "" : text;
  }

  associationAidFromReportValue(value) {
    const raw = String(value || "");
    const linkMatch = raw.match(/search-query=([^&\s"'<>]+)[^<>"']*search-type=association/i);
    if (linkMatch) {
      const decodedValue = decodeURIComponent(linkMatch[1].replace(/\+/g, " "));
      if (this.isValidAssociationAid(decodedValue)) return decodedValue;
    }

    const text = this.reportOptionalText(raw);
    const membershipMatch = text.match(/\bin\s+([A-Za-z0-9_]+)\b/);
    if (membershipMatch && this.isValidAssociationAid(membershipMatch[1])) return membershipMatch[1];
    if (this.isValidAssociationAid(text)) return text;
    return "";
  }

  firstReportInteger(value) {
    const match = this.reportPlainText(value).match(/\d+/);
    return match ? match[0] : "";
  }

  objectOidFromQuery(query) {
    const match = String(query || "").match(/\boid\s*\(\s*(\d+)\s*\)/i);
    return match ? match[1] : "";
  }

  objectBestAssociationFromReport(data) {
    const tables = Array.isArray(data) ? data : [];
    const propertyNames = [
      "best_asso",
      "@best_asso",
      "bestasso",
      "best_association",
      "best association",
      "best_moca_aid",
      "best matching moca_aid",
      "best_matching_moca_aid",
    ];
    const bestMembershipIdLabelKeys = [
      "moca_aid",
      "moca aid",
      "best_asso",
      "@best_asso",
      "best asso",
    ].map((label) => this.reportTextForDetection(label).replace(/:+$/g, ""));
    const bestMembershipAssociationLabelKeys = [
      "association",
      "best membership",
    ].map((label) => this.reportTextForDetection(label).replace(/:+$/g, ""));

    for (const table of tables) {
      for (const propertyName of propertyNames) {
        const value = this.reportOptionalText(table?.[propertyName]);
        if (value) return value;
      }

      const rows = Array.isArray(table?.data) ? table.data : [];
      const tableTitle = this.reportTextForDetection(table?.title).replace(/:+$/g, "");
      const isBestMembershipSection = tableTitle.includes("best membership");

      for (const row of rows) {
        const key = this.reportTextForDetection(row?.label).replace(/:+$/g, "");
        if (key == "best membership" || key.includes("best membership")) {
          const value = this.associationAidFromReportValue(row?.value);
          if (value) return value;
        }
      }

      if (isBestMembershipSection) {
        for (const row of rows) {
          const key = this.reportTextForDetection(row?.label).replace(/:+$/g, "");
          if (bestMembershipIdLabelKeys.some((labelKey) => key == labelKey || key.includes(labelKey))) {
            const value = this.reportOptionalText(row?.value);
            if (value) return value;
          }
        }

        for (const row of rows) {
          const key = this.reportTextForDetection(row?.label).replace(/:+$/g, "");
          if (bestMembershipAssociationLabelKeys.some((labelKey) => key == labelKey || key.includes(labelKey))) {
            const value = this.reportOptionalText(row?.value);
            if (this.isValidAssociationAid(value)) return value;
          }
        }
      }

      for (const row of rows) {
        for (const propertyName of propertyNames) {
          const value = this.reportOptionalText(row?.[propertyName]);
          if (value) return value;
        }
      }
    }

    const bestAssociationField = this.findReportFieldByLabelText(data, [
      "@best_asso",
      "best_asso",
      "best asso",
      "best moca_aid",
      "best matching moca_aid",
      "best matching association",
      "best association",
    ]);

    return this.reportOptionalText(bestAssociationField?.value);
  }

  objectCmdTargetFromReport(data, query) {
    const oidField = this.findReportFieldByLabelText(data, ["moca_oid", "moca oid"]);
    const designationField = this.findReportFieldByLabelText(data, ["designation"]);

    return {
      mocaOid: this.firstReportInteger(oidField?.value) || this.objectOidFromQuery(query),
      designation: this.reportPlainText(designationField?.value),
      bestAsso: this.objectBestAssociationFromReport(data),
    };
  }

  isValidAssociationAid(mocaAid) {
    return /^[A-Za-z0-9_]+$/.test(String(mocaAid || "").trim());
  }

  showAssociationExports(mocaAid) {
    const cleanAid = String(mocaAid || "").trim();
    const wrapper = $("#association-export-actions");
    if (wrapper.length == 0 || !this.isValidAssociationAid(cleanAid)) {
      this.hideAssociationExports();
      return;
    }

    const endpoint = `/api/association/${encodeURIComponent(cleanAid)}/export.csv`;
    $("#association-export-compact").attr("href", `${endpoint}?profile=compact`);
    $("#association-export-full").attr("href", `${endpoint}?profile=full`);
    wrapper.prop("hidden", false);
  }

  hideAssociationExports() {
    $("#association-export-actions").prop("hidden", true);
    $("#association-export-compact, #association-export-full").attr("href", "#");
  }

  isValidObjectOid(mocaOid) {
    return /^[1-9][0-9]*$/.test(String(mocaOid || "").trim());
  }

  showObjectExports(mocaOid) {
    const cleanOid = String(mocaOid || "").trim();
    const wrapper = $("#object-export-actions");
    if (wrapper.length == 0 || !this.isValidObjectOid(cleanOid)) {
      this.hideObjectExports();
      return;
    }

    const endpoint = `/api/object/${encodeURIComponent(cleanOid)}/export.csv`;
    $("#object-export-short").attr("href", `${endpoint}?profile=short`);
    $("#object-export-complete").attr("href", `${endpoint}?profile=complete`);
    wrapper.prop("hidden", false);
  }

  hideObjectExports() {
    $("#object-export-actions").prop("hidden", true);
    $("#object-export-short, #object-export-complete").attr("href", "#");
  }

  objectFinderCharts() {
    return [
      {selector: "#aladin-lite-div-1", survey: "CDS/P/DSS2/color", coverageIds: ["CDS/P/DSS2/color"]},
      {selector: "#aladin-lite-div-3", survey: "CDS/P/PanSTARRS/DR1/color-i-r-g", coverageIds: ["CDS/P/PanSTARRS/DR1/color-i-r-g"]},
      {selector: "#aladin-lite-div-2", survey: "CDS/P/unWISE/color-W2-W1W2-W1", coverageIds: ["CDS/P/unWISE/color-W2-W1W2-W1"]},
      {selector: "#aladin-lite-div-4", survey: "CDS/P/DES-DR2/ColorIRG", coverageIds: ["CDS/P/DES-DR2/ColorIRG"]},
      {selector: "#aladin-lite-div-5", survey: "CDS/P/DES-DR2/z", coverageIds: ["CDS/P/DES-DR2/z"]},
      {selector: "#aladin-lite-div-6", survey: "CDS/P/2MASS/color", coverageIds: ["CDS/P/2MASS/color"]},
      {
        selector: "#aladin-lite-div-7",
        survey: "https://alasky.cds.unistra.fr/WFAU/wfau.roe.ac.uk_P_UHSDR1_J",
        coverageIds: ["wfau.roe.ac.uk/P/UHSDR1/J"],
      },
      {selector: "#aladin-lite-div-8", survey: "VOXASTRO/P/VHS/JKs/color", coverageIds: ["VOXASTRO/P/VHS/JKs/color"]},
      {selector: "#aladin-lite-div-9", survey: "VOXASTRO/P/UKIDSS/JHK/color", coverageIds: ["VOXASTRO/P/UKIDSS/JHK/color"]},
    ];
  }

  finderChartWrapper(selector) {
    const widget = $(selector);
    return widget.closest(".finder-chart");
  }

  setFinderChartVisible(selector, visible) {
    const wrapper = this.finderChartWrapper(selector);
    if (wrapper.length > 0) {
      wrapper.prop("hidden", !visible);
      return;
    }

    const widget = $(selector);
    widget.prop("hidden", !visible);
    widget.prev(".finder-chart-caption").prop("hidden", !visible);
  }

  hideObjectFinderCharts() {
    this.objectFinderCharts().forEach((finderChart) => {
      this.setFinderChartVisible(finderChart.selector, false);
    });
  }

  objectFinderChartCoverageRegion(raDeg, decDeg, fovDeg) {
    const ra = parseFloat(raDeg);
    const dec = parseFloat(decDeg);
    const fov = parseFloat(fovDeg);

    if (!Number.isFinite(ra) || !Number.isFinite(dec) || !Number.isFinite(fov)) return null;

    const radius = fov * Math.SQRT2 / 2;
    return `Circle ${ra} ${dec} ${radius}`;
  }

  fetchFinderChartCoverageIds(raDeg, decDeg, fovDeg) {
    const region = this.objectFinderChartCoverageRegion(raDeg, decDeg, fovDeg);
    if (!region) return Promise.resolve(null);

    const params = new URLSearchParams({
      expr: "dataproduct_type=image",
      get: "record",
      fmt: "json",
      fields: "ID",
      stc: region,
    });

    return fetch(`https://alaskybis.unistra.fr/MocServer/query?${params.toString()}`)
      .then((response) => {
        if (!response.ok) throw new Error(`MOCServer coverage request failed with status ${response.status}`);
        return response.json();
      })
      .then((records) => {
        return new Set((Array.isArray(records) ? records : [])
          .map((record) => String(record.ID || "").toLowerCase())
          .filter((id) => id.length > 0));
      });
  }

  finderChartHasCoverage(finderChart, coverageIds) {
    if (!(coverageIds instanceof Set)) return true;

    return (finderChart.coverageIds || [finderChart.survey]).some((id) => {
      return coverageIds.has(String(id || "").toLowerCase());
    });
  }

  initObjectFinderCharts(raDeg, decDeg) {
    const target = `${raDeg} ${decDeg}`;
    const finderChartFovDeg = 3 / 60;
    const finderCharts = this.objectFinderCharts();

    this.hideObjectFinderCharts();

    this.fetchFinderChartCoverageIds(raDeg, decDeg, finderChartFovDeg)
      .catch((error) => {
        console.warn("Could not check finder chart coverage; showing all Aladin finder charts.", error);
        return null;
      })
      .then((coverageIds) => {
        const chartsToShow = finderCharts.filter((finderChart) => {
          return this.finderChartHasCoverage(finderChart, coverageIds);
        });

        return A.init.then(() => {
          chartsToShow.forEach((finderChart) => {
            this.setFinderChartVisible(finderChart.selector, true);
            A.aladin(finderChart.selector, {
              survey: finderChart.survey,
              fov: finderChartFovDeg,
              target: target,
            });
            this.setupAladinZoomLock(finderChart.selector);
          });
        });
      });
  }

  setupAladinZoomLock(selector) {
    const widget = $(selector);
    if (widget.length == 0) return;

    if (!widget.parent().hasClass("aladin-lock-wrapper")) {
      widget.wrap("<div class='aladin-lock-wrapper is-zoom-locked'></div>");
      widget.before("<button class='aladin-zoom-lock-toggle' type='button'></button>");
    }

    const wrapper = widget.parent(".aladin-lock-wrapper");
    const button = $(".aladin-zoom-lock-toggle", wrapper);
    const setLocked = (locked) => {
      wrapper.toggleClass("is-zoom-locked", locked);
      wrapper.toggleClass("is-zoom-unlocked", !locked);
      button
        .text(locked ? "Unlock zoom" : "Lock zoom")
        .attr("aria-pressed", locked ? "true" : "false")
        .attr("aria-label", locked ? "Unlock Aladin zoom" : "Lock Aladin zoom");
    };
    const blockZoomWhenLocked = (event) => {
      if (!wrapper.hasClass("is-zoom-locked")) return;
      event.stopImmediatePropagation();
    };

    setLocked(true);
    button.off("click.mocaZoomLock").on("click.mocaZoomLock", () => {
      setLocked(!wrapper.hasClass("is-zoom-locked"));
    });

    if (widget.data("mocaZoomLockBound")) return;

    const widgetElement = widget.get(0);
    ["wheel", "mousewheel", "DOMMouseScroll", "gesturestart", "gesturechange", "gestureend", "dblclick"].forEach((eventName) => {
      widgetElement.addEventListener(eventName, blockZoomWhenLocked, true);
    });
    widget.data("mocaZoomLockBound", true);
  }

  setupAssociationSceneZoomLock(sceneState, buttonSelector, sceneLabel) {
    const button = document.querySelector(buttonSelector);
    if (!sceneState?.controls || !sceneState.container || !button) return;

    const frame = sceneState.container.closest(".moca-xyz-scene-frame");
    const setLocked = (locked) => {
      sceneState.zoomLocked = locked;
      sceneState.controls.enableZoom = !locked;
      sceneState.controls.update();
      if (frame) {
        frame.classList.toggle("is-zoom-locked", locked);
        frame.classList.toggle("is-zoom-unlocked", !locked);
      }
      button.hidden = false;
      button.textContent = locked ? "Unlock zoom" : "Lock zoom";
      button.setAttribute("aria-pressed", locked ? "true" : "false");
      button.setAttribute("aria-label", `${locked ? "Unlock" : "Lock"} ${sceneLabel} scene zoom`);
    };
    const onClick = (event) => {
      event.preventDefault();
      setLocked(!sceneState.zoomLocked);
    };

    setLocked(true);
    button.addEventListener("click", onClick);
    sceneState.eventListeners.push([button, "click", onClick]);
    sceneState.zoomLockButton = button;
    sceneState.zoomLockFrame = frame;
  }

  resetAssociationSceneZoomLock(sceneState) {
    if (sceneState?.zoomLockButton) {
      sceneState.zoomLockButton.hidden = true;
      sceneState.zoomLockButton.textContent = "Unlock zoom";
      sceneState.zoomLockButton.setAttribute("aria-pressed", "true");
    }
    if (sceneState?.zoomLockFrame) {
      sceneState.zoomLockFrame.classList.remove("is-zoom-locked", "is-zoom-unlocked");
    }
  }

  showAssociationSearchWidgets() {
    $("#moca-cmd-wrapper, #moca-xyz-wrapper, #moca-uvw-wrapper").prop("hidden", false);
  }

  hideAssociationSearchWidgets() {
    this.disposeAssociationXyzScene();
    this.disposeAssociationUvwScene();
    this.setAssociationCmdLoading(false);
    this.setAssociationXyzLoading(false);
    this.setAssociationUvwLoading(false);
    $("#moca-cmd-wrapper, #moca-xyz-wrapper, #moca-uvw-wrapper").prop("hidden", true);
    $("#moca-cmd-dataviz, #moca-xyz-dataviz, #moca-uvw-dataviz, #moca-cmd-selection").prop("hidden", true).empty();
  }

  hideAssociationUvFigure() {
    $("#association-uv-figure-copy, #association-image-wrapper").prop("hidden", true);
    $("#association-image-wrapper .results").empty();
  }

  loadAssociationUvFigure(mocaAid) {
    const wrapper = $("#association-image-wrapper");
    const copy = $("#association-uv-figure-copy");
    const results = $(".results", wrapper);
    if (wrapper.length == 0 || copy.length == 0 || results.length == 0) return;

    this.hideAssociationUvFigure();

    const endpoint = results.data("image-endpoint");
    if (!endpoint) return;

    $.ajax({
      dataType: "json",
      method: "get",
      url: `${endpoint}/${encodeURIComponent(mocaAid)}`,
      success: (data) => {
        const imageUrl = data?.url ? `${data.url}/download` : "";
        if (!imageUrl) return;

        const image = new Image();
        image.onload = () => {
          results.empty().append($("<div class='image-wrapper'></div>").append(image));
          copy.prop("hidden", false);
          wrapper.prop("hidden", false);
          this.anim.attach();
          this.anim.resize();
        };
        image.onerror = () => {
          this.hideAssociationUvFigure();
        };
        image.src = imageUrl;
      },
      error: () => {
        this.hideAssociationUvFigure();
      },
    });
  }

  hideObjectCmd() {
    const wrapper = $("#moca-object-cmd-wrapper");
    if (wrapper.length == 0) return;

    this.setObjectCmdLoading(false);
    wrapper.prop("hidden", true);
    wrapper.find(".moca-object-cmd-target-overlay").prop("hidden", true);
    $("#moca-object-cmd-status").removeClass("loading error").text("CMD unavailable");
    $("#moca-object-cmd-summary").text("No data loaded");
    $("#moca-object-cmd-dataviz").prop("hidden", true).empty();
  }

  loadObjectCmd(reportRows, query) {
    const wrapper = $("#moca-object-cmd-wrapper");
    if (wrapper.length == 0) return;

    this.hideObjectCmd();

    const target = this.objectCmdTargetFromReport(reportRows, query);
    if (!target.mocaOid) return;

    this.setObjectCmdStatus("Loading CMD", "loading");
    this.setObjectCmdLoading(true);

    this.fetchObjectCmdRow(target.mocaOid).then((objectRows) => {
      if (objectRows.length == 0) {
        this.hideObjectCmd();
        return null;
      }

      wrapper.prop("hidden", false);
      return Promise.all([
        this.loadPlotly(),
        Promise.resolve(objectRows),
        this.fetchAssociationCmdFieldRows().catch((error) => {
          console.log("MOCAdb object CMD field error:", error);
          return [];
        }),
        this.fetchAssociationCmdSequenceRows().catch((error) => {
          console.log("MOCAdb object CMD sequence error:", error);
          return [];
        }),
      ]);
    }).then((values) => {
      if (!values) return;
      const objectRows = values[1] || [];
      const fieldRows = values[2] || [];
      const sequenceRows = values[3] || [];
      this.renderObjectCmd(objectRows[0], target, fieldRows, sequenceRows);
    }).catch((error) => {
      console.log("MOCAdb object CMD error:", error);
      this.hideObjectCmd();
    });
  }

  loadAssociationCmd(mocaAid) {
    const wrapper = $("#moca-cmd-wrapper");
    if (wrapper.length == 0) return;

    const cleanedAid = String(mocaAid || "").trim();
    if (!this.isValidAssociationAid(cleanedAid)) {
      this.setAssociationCmdStatus("CMD unavailable for this association ID", "error");
      this.setAssociationCmdLoading(false);
      return;
    }

    this.setAssociationCmdStatus("Loading CMD", "loading");
    this.setAssociationCmdLoading(true);
    this.renderAssociationCmdDatavizLink(cleanedAid);

    Promise.all([
      this.loadPlotly(),
      this.fetchAssociationCmdRows(cleanedAid),
      this.fetchAssociationCmdFieldRows().catch((error) => {
        console.log("MOCAdb CMD field error:", error);
        return [];
      }),
      this.fetchAssociationCmdSequenceRows().catch((error) => {
        console.log("MOCAdb CMD sequence error:", error);
        return [];
      }),
    ]).then((values) => {
      const rows = values[1] || [];
      const fieldRows = values[2] || [];
      const sequenceRows = values[3] || [];
      this.renderAssociationCmd(rows, cleanedAid, fieldRows, sequenceRows);
    }).catch((error) => {
      console.log("MOCAdb CMD error:", error);
      this.setAssociationCmdStatus(error.message || "CMD unavailable", "error");
      this.setAssociationCmdLoading(false);
    });
  }

  loadPlotly() {
    if (window.Plotly) return Promise.resolve(window.Plotly);
    if (this.plotlyLoader) return this.plotlyLoader;

    this.plotlyLoader = new Promise((resolve, reject) => {
      const existingScript = document.querySelector("script[data-moca-plotly]");
      if (existingScript) {
        existingScript.addEventListener("load", () => resolve(window.Plotly));
        existingScript.addEventListener("error", () => reject(new Error("Could not load Plotly")));
        return;
      }

      const script = document.createElement("script");
      script.src = "https://cdn.plot.ly/plotly-2.35.2.min.js";
      script.async = true;
      script.dataset.mocaPlotly = "1";
      script.onload = () => {
        if (window.Plotly) resolve(window.Plotly);
        else reject(new Error("Plotly loaded without exposing Plotly"));
      };
      script.onerror = () => reject(new Error("Could not load Plotly"));
      document.head.appendChild(script);
    });

    return this.plotlyLoader;
  }

  loadThree() {
    if (window.THREE && window.THREE.OrbitControls) return Promise.resolve(window.THREE);
    if (this.threeLoader) return this.threeLoader;

    const loadCore = new Promise((resolve, reject) => {
      const existingScript = document.querySelector("script[data-moca-three]");
      if (existingScript) {
        existingScript.addEventListener("load", () => resolve(window.THREE));
        existingScript.addEventListener("error", () => reject(new Error("Could not load Three.js")));
        return;
      }

      const script = document.createElement("script");
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js";
      script.async = true;
      script.dataset.mocaThree = "1";
      script.onload = () => {
        if (window.THREE) resolve(window.THREE);
        else reject(new Error("Three.js loaded without exposing THREE"));
      };
      script.onerror = () => reject(new Error("Could not load Three.js"));
      document.head.appendChild(script);
    });

    this.threeLoader = loadCore
      .then(() => this.loadThreeOrbitControls())
      .then(() => this.loadThreeMarchingCubes().catch((error) => {
        console.log("MOCAdb XYZ MarchingCubes load error:", error);
        return null;
      }))
      .then(() => window.THREE);
    return this.threeLoader;
  }

  loadThreeOrbitControls() {
    if (window.THREE?.OrbitControls) return Promise.resolve(window.THREE.OrbitControls);

    return new Promise((resolve, reject) => {
      const existingScript = document.querySelector("script[data-moca-three-orbit-controls]");
      if (existingScript) {
        existingScript.addEventListener("load", () => resolve(window.THREE?.OrbitControls));
        existingScript.addEventListener("error", () => reject(new Error("Could not load Three.js OrbitControls")));
        return;
      }

      const script = document.createElement("script");
      script.src = "https://unpkg.com/three@0.128.0/examples/js/controls/OrbitControls.js";
      script.async = true;
      script.dataset.mocaThreeOrbitControls = "1";
      script.onload = () => {
        if (window.THREE?.OrbitControls) resolve(window.THREE.OrbitControls);
        else reject(new Error("OrbitControls loaded without exposing THREE.OrbitControls"));
      };
      script.onerror = () => reject(new Error("Could not load Three.js OrbitControls"));
      document.head.appendChild(script);
    });
  }

  loadThreeMarchingCubes() {
    if (window.THREE?.MarchingCubes) return Promise.resolve(window.THREE.MarchingCubes);

    return new Promise((resolve, reject) => {
      const existingScript = document.querySelector("script[data-moca-three-marching-cubes]");
      if (existingScript) {
        existingScript.addEventListener("load", () => resolve(window.THREE?.MarchingCubes));
        existingScript.addEventListener("error", () => reject(new Error("Could not load Three.js MarchingCubes")));
        return;
      }

      const script = document.createElement("script");
      script.src = "https://unpkg.com/three@0.128.0/examples/js/objects/MarchingCubes.js";
      script.async = true;
      script.dataset.mocaThreeMarchingCubes = "1";
      script.onload = () => {
        if (window.THREE?.MarchingCubes) resolve(window.THREE.MarchingCubes);
        else reject(new Error("MarchingCubes loaded without exposing THREE.MarchingCubes"));
      };
      script.onerror = () => reject(new Error("Could not load Three.js MarchingCubes"));
      document.head.appendChild(script);
    });
  }

  fetchAssociationCmdRows(mocaAid) {
    const query = `
      SELECT
        sam.moca_oid,
        sam.designation,
        sam.moca_aid,
        sam.moca_mtid,
        sam.spectral_type,
        sam.sptn,
        ROUND(sam.bmag - sam.rmag, 5) AS bp_rp,
        ROUND(sam.gmag - sam.dmod, 5) AS abs_g,
        ROUND(sam.gmag, 5) AS gmag,
        ROUND(sam.bmag, 5) AS bpmag,
        ROUND(sam.rmag, 5) AS rpmag,
        ROUND(sam.dmod, 5) AS dmod,
        ROUND(sam.parallax_mas, 5) AS parallax_mas,
        ROUND(sam.dr3_ruwe, 5) AS dr3_ruwe,
        ROUND(sam.banyan_prob, 3) AS banyan_prob,
        ROUND(sam.banyan_uvw_sep_kms, 3) AS banyan_uvw_sep_kms
      FROM summary_all_members sam
      JOIN cat_gaiadr3 g
        ON g.moca_oid = sam.moca_oid
      WHERE sam.moca_aid = '${mocaAid}'
        AND sam.moca_mtid IN ('BF', 'HM', 'CM', 'LM')
        AND sam.bmag IS NOT NULL
        AND sam.rmag IS NOT NULL
        AND sam.gmag IS NOT NULL
        AND sam.dmod IS NOT NULL
        ${this.associationCmdStrictGaiaPhotometryFilterSql("g")}
      ORDER BY
        CASE sam.moca_mtid
          WHEN 'BF' THEN 1
          WHEN 'HM' THEN 2
          WHEN 'CM' THEN 3
          WHEN 'LM' THEN 4
          ELSE 5
        END,
        sam.bmag - sam.rmag
    `;

    return this.queryAssociationCmdApi(query, 10000, "Could not query CMD data");
  }

  fetchObjectCmdRow(mocaOid) {
    const oid = Number(mocaOid);
    if (!Number.isInteger(oid) || oid <= 0) return Promise.resolve([]);

    const query = `
      SELECT
        mo.moca_oid,
        mo.designation AS object_designation,
        g.source_id,
        g.designation AS gaia_designation,
        ROUND(g.phot_bp_mean_mag - g.phot_rp_mean_mag, 5) AS bp_rp,
        ROUND(g.phot_g_mean_mag - COALESCE(g.dmod, 5 * LOG10(1000 / g.parallax) - 5), 5) AS abs_g,
        ROUND(g.phot_g_mean_mag, 5) AS gmag,
        ROUND(g.phot_bp_mean_mag, 5) AS bpmag,
        ROUND(g.phot_rp_mean_mag, 5) AS rpmag,
        ROUND(COALESCE(g.dmod, 5 * LOG10(1000 / g.parallax) - 5), 5) AS dmod,
        ROUND(g.ruwe, 5) AS dr3_ruwe,
        ROUND(g.parallax, 5) AS parallax_mas
      FROM moca_objects mo
      JOIN cat_gaiadr3 g
        ON g.moca_oid = mo.moca_oid
      WHERE mo.moca_oid = ${oid}
        AND g.parallax IS NOT NULL
        AND g.parallax > 0
        AND g.phot_bp_mean_mag IS NOT NULL
        AND g.phot_rp_mean_mag IS NOT NULL
        AND g.phot_g_mean_mag IS NOT NULL
      ORDER BY
        COALESCE(g.parallax_over_error, 0) DESC,
        g.id DESC
    `;

    return this.queryAssociationCmdApi(query, 1, "Could not query object CMD data");
  }

  fetchAssociationCmdFieldRows() {
    const query = `
      SELECT
        field.source_id,
        field.designation,
        ROUND(field.phot_bp_mean_mag - field.phot_rp_mean_mag, 5) AS bp_rp,
        ROUND(field.phot_g_mean_mag - 5 * LOG10(1000 / field.parallax) + 5, 5) AS abs_g,
        ROUND(field.phot_g_mean_mag, 5) AS gmag,
        ROUND(field.phot_bp_mean_mag, 5) AS bpmag,
        ROUND(field.phot_rp_mean_mag, 5) AS rpmag,
        ROUND(field.ruwe, 5) AS dr3_ruwe,
        ROUND(field.parallax, 5) AS parallax_mas
      FROM cat_gaiadr3_100pc_field field
      WHERE field.parallax IS NOT NULL
        AND field.parallax > 0
        AND field.phot_bp_mean_mag IS NOT NULL
        AND field.phot_rp_mean_mag IS NOT NULL
        AND field.phot_g_mean_mag IS NOT NULL
        ${this.associationCmdStrictGaiaPhotometryFilterSql("field")}
    `;

    return this.queryAssociationCmdApi(query, 10000, "Could not query CMD field data");
  }

  associationCmdStrictGaiaPhotometryFilterSql(alias) {
    // Keep this gate in sync with mocaviz/app.py::_gaia_cmd_gaia_quality_filter_sql(..., "strict").
    const color = `COALESCE(${alias}.bp_rp, ${alias}.phot_bp_mean_mag - ${alias}.phot_rp_mean_mag)`;

    return `
      AND COALESCE(${alias}.duplicated_source, 0) = 0
      AND COALESCE(${alias}.in_qso_candidates, 0) = 0
      AND COALESCE(${alias}.in_galaxy_candidates, 0) = 0
      AND ${color} IS NOT NULL
      AND ${alias}.phot_bp_rp_excess_factor BETWEEN
        1.0 + 0.015 * POW(${color}, 2)
        AND 1.3 + 0.06 * POW(${color}, 2)
      AND ${alias}.ruwe <= 1.4
      AND COALESCE(${alias}.phot_proc_mode, 0) = 0
      AND ${alias}.phot_g_mean_flux_over_error >= 100
      AND ${alias}.phot_bp_mean_flux_over_error >= 20
      AND ${alias}.phot_rp_mean_flux_over_error >= 20
      AND COALESCE(${alias}.phot_bp_n_contaminated_transits, 0) = 0
      AND COALESCE(${alias}.phot_rp_n_contaminated_transits, 0) = 0
      AND COALESCE(${alias}.phot_bp_n_blended_transits, 0) = 0
      AND COALESCE(${alias}.phot_rp_n_blended_transits, 0) = 0
      AND (${alias}.ipd_frac_multi_peak IS NULL OR ${alias}.ipd_frac_multi_peak <= 2)
      AND (${alias}.ipd_frac_odd_win IS NULL OR ${alias}.ipd_frac_odd_win <= 10)
      AND (${alias}.ipd_gof_harmonic_amplitude IS NULL OR ${alias}.ipd_gof_harmonic_amplitude <= 0.1)
    `;
  }

  fetchAssociationCmdSequenceRows() {
    const query = `
      SELECT
        ms.moca_seqid,
        COALESCE(ms.name_bdcolapp, ms.moca_seqid) AS name,
        ROUND(das.xdata, 5) AS xdata,
        ROUND(das.ydata, 5) AS ydata,
        ROUND(das.yerror, 5) AS yerror
      FROM moca_sequences ms
      JOIN data_astro_sequences das
        ON das.moca_seqid = ms.moca_seqid
      WHERE ms.moca_seqid IN (
          'bprp_mg_gaiadr3_ext_field',
          'bprp_mg_gaiadr3_ext_mel5',
          'bprp_mg_gaiadr3_ext_abdmg',
          'bprp_mg_gaiadr3_ext_tha',
          'bprp_mg_gaiadr3_ext_bpmg',
          'bprp_mg_gaiadr3_ext_twa',
          'bprp_mg_gaiadr3_ext_etac'
        )
        AND ms.display_in_bdcolapp = 1
        AND ms.ignored = 0
        AND das.ignored = 0
        AND das.xdata IS NOT NULL
        AND das.ydata IS NOT NULL
      ORDER BY ms.moca_seqid, das.xdata
    `;

    return this.queryAssociationCmdApi(query, 10000, "Could not query CMD sequence data");
  }

  queryAssociationCmdApi(query, limit, errorMessage) {
    return this.queryAssociationApi(query, limit, errorMessage);
  }

  queryAssociationApi(query, limit, errorMessage) {
    return new Promise((resolve, reject) => {
      $.ajax({
        dataType: "json",
        method: "post",
        url: "/api/query",
        data: {
          query: this.compactSql(query),
          offset: 0,
          limit: limit,
        },
        success: (data) => {
          if (typeof data == "string" && data.indexOf("Error:") == 0) {
            reject(new Error(data));
            return;
          }
          resolve(Array.isArray(data) ? data : []);
        },
        error: (error) => reject(new Error(error.responseText || errorMessage)),
      });
    });
  }

  loadAssociationXyz(mocaAid) {
    const wrapper = $("#moca-xyz-wrapper");
    if (wrapper.length == 0) return;

    const cleanedAid = String(mocaAid || "").trim();
    if (!this.isValidAssociationAid(cleanedAid)) {
      this.setAssociationXyzStatus("XYZ unavailable for this association ID", "error");
      this.setAssociationXyzLoading(false);
      return;
    }

    this.setAssociationXyzStatus("Loading XYZ", "loading");
    this.setAssociationXyzLoading(true);
    this.renderAssociationXyzDatavizLink(cleanedAid);

    Promise.all([
      this.loadThree(),
      this.fetchAssociationXyzRows(cleanedAid),
      this.fetchAssociationXyzModelRows(cleanedAid).catch((error) => {
        console.log("MOCAdb XYZ model error:", error);
        return [];
      }),
      this.fetchAssociationXyzModelComponentRows(cleanedAid).catch((error) => {
        console.log("MOCAdb XYZ model component error:", error);
        return [];
      }),
    ]).then((values) => {
      const rows = values[1] || [];
      const modelRows = values[2] || [];
      const modelComponentRows = values[3] || [];
      this.renderAssociationXyz(rows, cleanedAid, modelRows, modelComponentRows);
    }).catch((error) => {
      console.log("MOCAdb XYZ error:", error);
      this.setAssociationXyzStatus(error.message || "XYZ unavailable", "error");
      this.setAssociationXyzLoading(false);
    });
  }

  fetchAssociationXyzRows(mocaAid) {
    const query = `
      SELECT
        sam.moca_oid,
        sam.designation,
        sam.moca_aid,
        sam.moca_mtid,
        sam.spectral_type,
        sam.sptn,
        ROUND(sam.x_pc, 5) AS x_pc,
        ROUND(sam.y_pc, 5) AS y_pc,
        ROUND(sam.z_pc, 5) AS z_pc,
        ROUND(sam.banyan_prob, 3) AS banyan_prob,
        ROUND(sam.banyan_uvw_sep_kms, 3) AS banyan_uvw_sep_kms,
        ROUND(cbs.ya_prob, 3) AS latest_bsigma_prob,
        ROUND(cbs.uvw_sep, 3) AS latest_bsigma_uvw_sep,
        cbs.moca_bsmdid
      FROM summary_all_members sam
      LEFT JOIN calc_banyan_sigma cbs
        ON cbs.moca_oid = sam.moca_oid
        AND cbs.moca_aid = sam.moca_aid
        AND cbs.max_observables = 1
        AND cbs.moca_bsmdid = (
          SELECT moca_bsmdid
          FROM moca_banyan_sigma_models
          WHERE adopted = 1
          ORDER BY moca_bsmdid DESC
          LIMIT 1
        )
      WHERE sam.moca_aid = '${mocaAid}'
        AND sam.moca_mtid IN ('BF', 'HM', 'CM', 'LM')
        AND sam.x_pc IS NOT NULL
        AND sam.y_pc IS NOT NULL
        AND sam.z_pc IS NOT NULL
      ORDER BY
        CASE sam.moca_mtid
          WHEN 'BF' THEN 1
          WHEN 'HM' THEN 2
          WHEN 'CM' THEN 3
          WHEN 'LM' THEN 4
          ELSE 5
        END,
        COALESCE(cbs.ya_prob, sam.banyan_prob) DESC
    `;

    return this.queryAssociationApi(query, 10000, "Could not query XYZ data");
  }

  fetchAssociationXyzModelRows(mocaAid) {
    const query = `
      SELECT
        cbmp.moca_aid,
        cbmp.moca_bsmdid,
        mbsm.model_name,
        ROUND(cbmp.avg_x_pc, 5) AS avg_x_pc,
        ROUND(cbmp.avg_y_pc, 5) AS avg_y_pc,
        ROUND(cbmp.avg_z_pc, 5) AS avg_z_pc,
        ROUND(cbmp.x_stddev, 5) AS x_stddev,
        ROUND(cbmp.y_stddev, 5) AS y_stddev,
        ROUND(cbmp.z_stddev, 5) AS z_stddev,
        cbmp.nobj,
        cbmp.nobj_for_stats
      FROM calc_banyan_sigma_model_properties cbmp
      JOIN moca_banyan_sigma_models mbsm
        ON mbsm.moca_bsmdid = cbmp.moca_bsmdid
      WHERE cbmp.moca_aid = '${mocaAid}'
        AND mbsm.adopted = 1
      ORDER BY cbmp.moca_bsmdid DESC
    `;

    return this.queryAssociationApi(query, 1, "Could not query XYZ model data");
  }

  fetchAssociationXyzModelComponentRows(mocaAid) {
    const query = `
      SELECT
        dbsm.moca_aid,
        dbsm.moca_bsmdid,
        dbsm.coeff_index,
        dbsm.coeff_amplitude,
        ROUND(dbsm.x_cen, 7) AS x_cen,
        ROUND(dbsm.y_cen, 7) AS y_cen,
        ROUND(dbsm.z_cen, 7) AS z_cen,
        dbsm.xx_covar,
        dbsm.xy_covar,
        dbsm.xz_covar,
        dbsm.yy_covar,
        dbsm.yz_covar,
        dbsm.zz_covar,
        dbsm.covariance_determ
      FROM data_banyan_sigma_models dbsm
      JOIN moca_banyan_sigma_models mbsm
        ON mbsm.moca_bsmdid = dbsm.moca_bsmdid
      WHERE dbsm.moca_aid = '${mocaAid}'
        AND mbsm.adopted = 1
        AND dbsm.ignored = 0
      ORDER BY dbsm.coeff_index
    `;

    return this.queryAssociationApi(query, 100, "Could not query XYZ model components");
  }

  loadAssociationUvw(mocaAid) {
    const wrapper = $("#moca-uvw-wrapper");
    if (wrapper.length == 0) return;

    const cleanedAid = String(mocaAid || "").trim();
    if (!this.isValidAssociationAid(cleanedAid)) {
      this.setAssociationUvwStatus("UVW unavailable for this association ID", "error");
      this.setAssociationUvwLoading(false);
      return;
    }

    this.setAssociationUvwStatus("Loading UVW", "loading");
    this.setAssociationUvwLoading(true);
    this.renderAssociationUvwDatavizLink(cleanedAid);

    Promise.all([
      this.loadThree(),
      this.fetchAssociationUvwRows(cleanedAid),
      this.fetchAssociationUvwModelRows(cleanedAid).catch((error) => {
        console.log("MOCAdb UVW model error:", error);
        return [];
      }),
      this.fetchAssociationUvwModelComponentRows(cleanedAid).catch((error) => {
        console.log("MOCAdb UVW model component error:", error);
        return [];
      }),
    ]).then((values) => {
      const rows = values[1] || [];
      const modelRows = values[2] || [];
      const modelComponentRows = values[3] || [];
      this.renderAssociationUvw(rows, cleanedAid, modelRows, modelComponentRows);
    }).catch((error) => {
      console.log("MOCAdb UVW error:", error);
      this.setAssociationUvwStatus(error.message || "UVW unavailable", "error");
      this.setAssociationUvwLoading(false);
    });
  }

  fetchAssociationUvwRows(mocaAid) {
    const query = `
      SELECT
        sam.moca_oid,
        sam.designation,
        sam.moca_aid,
        sam.moca_mtid,
        sam.spectral_type,
        sam.sptn,
        ROUND(sam.u_kms, 5) AS u_kms,
        ROUND(sam.v_kms, 5) AS v_kms,
        ROUND(sam.w_kms, 5) AS w_kms,
        ROUND(sam.banyan_prob, 3) AS banyan_prob,
        ROUND(sam.banyan_uvw_sep_kms, 3) AS banyan_uvw_sep_kms,
        ROUND(cbs.ya_prob, 3) AS latest_bsigma_prob,
        ROUND(cbs.uvw_sep, 3) AS latest_bsigma_uvw_sep,
        cbs.moca_bsmdid
      FROM summary_all_members sam
      LEFT JOIN calc_banyan_sigma cbs
        ON cbs.moca_oid = sam.moca_oid
        AND cbs.moca_aid = sam.moca_aid
        AND cbs.max_observables = 1
        AND cbs.moca_bsmdid = (
          SELECT moca_bsmdid
          FROM moca_banyan_sigma_models
          WHERE adopted = 1
          ORDER BY moca_bsmdid DESC
          LIMIT 1
        )
      WHERE sam.moca_aid = '${mocaAid}'
        AND sam.moca_mtid IN ('BF', 'HM', 'CM', 'LM')
        AND sam.u_kms IS NOT NULL
        AND sam.v_kms IS NOT NULL
        AND sam.w_kms IS NOT NULL
      ORDER BY
        CASE sam.moca_mtid
          WHEN 'BF' THEN 1
          WHEN 'HM' THEN 2
          WHEN 'CM' THEN 3
          WHEN 'LM' THEN 4
          ELSE 5
        END,
        COALESCE(cbs.ya_prob, sam.banyan_prob) DESC
    `;

    return this.queryAssociationApi(query, 10000, "Could not query UVW data");
  }

  fetchAssociationUvwModelRows(mocaAid) {
    const query = `
      SELECT
        cbmp.moca_aid,
        cbmp.moca_bsmdid,
        mbsm.model_name,
        ROUND(cbmp.avg_u_kms, 5) AS avg_u_kms,
        ROUND(cbmp.avg_v_kms, 5) AS avg_v_kms,
        ROUND(cbmp.avg_w_kms, 5) AS avg_w_kms,
        ROUND(cbmp.u_stddev, 5) AS u_stddev,
        ROUND(cbmp.v_stddev, 5) AS v_stddev,
        ROUND(cbmp.w_stddev, 5) AS w_stddev,
        cbmp.nobj,
        cbmp.nobj_for_stats
      FROM calc_banyan_sigma_model_properties cbmp
      JOIN moca_banyan_sigma_models mbsm
        ON mbsm.moca_bsmdid = cbmp.moca_bsmdid
      WHERE cbmp.moca_aid = '${mocaAid}'
        AND mbsm.adopted = 1
      ORDER BY cbmp.moca_bsmdid DESC
    `;

    return this.queryAssociationApi(query, 1, "Could not query UVW model data");
  }

  fetchAssociationUvwModelComponentRows(mocaAid) {
    const query = `
      SELECT
        dbsm.moca_aid,
        dbsm.moca_bsmdid,
        dbsm.coeff_index,
        dbsm.coeff_amplitude,
        ROUND(dbsm.u_cen, 7) AS u_cen,
        ROUND(dbsm.v_cen, 7) AS v_cen,
        ROUND(dbsm.w_cen, 7) AS w_cen,
        dbsm.uu_covar,
        dbsm.uv_covar,
        dbsm.uw_covar,
        dbsm.vv_covar,
        dbsm.vw_covar,
        dbsm.ww_covar,
        dbsm.covariance_determ
      FROM data_banyan_sigma_models dbsm
      JOIN moca_banyan_sigma_models mbsm
        ON mbsm.moca_bsmdid = dbsm.moca_bsmdid
      WHERE dbsm.moca_aid = '${mocaAid}'
        AND mbsm.adopted = 1
        AND dbsm.ignored = 0
      ORDER BY dbsm.coeff_index
    `;

    return this.queryAssociationApi(query, 100, "Could not query UVW model components");
  }

  renderAssociationXyz(rows, mocaAid, modelRows = [], modelComponentRows = []) {
    const container = document.getElementById("moca-xyz-scene");
    if (!container || !window.THREE) {
      this.setAssociationXyzStatus("Three.js unavailable", "error");
      this.setAssociationXyzLoading(false);
      return;
    }

    const parsedRows = rows.map((row) => {
      return {
        ...row,
        x: this.numericOrNull(row.x_pc),
        y: this.numericOrNull(row.y_pc),
        z: this.numericOrNull(row.z_pc),
        sptn: this.numericOrNull(row.sptn),
        banyan_prob: this.numericOrNull(row.banyan_prob),
        banyan_uvw_sep_kms: this.numericOrNull(row.banyan_uvw_sep_kms),
        latest_bsigma_prob: this.numericOrNull(row.latest_bsigma_prob),
        latest_bsigma_uvw_sep: this.numericOrNull(row.latest_bsigma_uvw_sep),
        moca_bsmdid: this.numericOrNull(row.moca_bsmdid),
      };
    }).filter((row) => row.x !== null && row.y !== null && row.z !== null);

    const models = modelRows.map((row) => {
      return {
        ...row,
        cx: this.numericOrNull(row.avg_x_pc),
        cy: this.numericOrNull(row.avg_y_pc),
        cz: this.numericOrNull(row.avg_z_pc),
        sx: this.numericOrNull(row.x_stddev),
        sy: this.numericOrNull(row.y_stddev),
        sz: this.numericOrNull(row.z_stddev),
        moca_bsmdid: this.numericOrNull(row.moca_bsmdid),
      };
    }).filter((row) => row.cx !== null && row.cy !== null && row.cz !== null
      && row.sx !== null && row.sy !== null && row.sz !== null
      && row.sx > 0 && row.sy > 0 && row.sz > 0);
    const modelComponents = this.parseAssociationXyzModelComponents(modelComponentRows);

    this.associationXyzRows = parsedRows;
    this.disposeAssociationXyzScene();

    if (parsedRows.length == 0 && models.length == 0) {
      this.setAssociationXyzStatus("No XYZ rows", "error");
      this.setAssociationXyzLoading(false);
      $("#moca-xyz-summary").text("No propagated members with XYZ coordinates were found.");
      return;
    }

    const THREE = window.THREE;
    const bounds = this.associationXyzBounds(parsedRows, models, modelComponents);
    const width = Math.max(320, container.clientWidth || container.getBoundingClientRect().width || 320);
    const height = Math.max(320, container.clientHeight || 380);
    const scene = new THREE.Scene();
    scene.background = null;
    const camera = new THREE.PerspectiveCamera(42, width / height, 0.01, Math.max(20000, bounds.radius * 80));
    camera.up.set(0, 0, 1);
    const renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true,
      premultipliedAlpha: false,
      powerPreference: "high-performance",
    });

    renderer.setClearColor(0x08090c, 0);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    if ("outputEncoding" in renderer && THREE.sRGBEncoding) renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.setSize(width, height);
    container.innerHTML = "";
    container.appendChild(renderer.domElement);

    const ambient = new THREE.AmbientLight(0xffffff, 0.62);
    const key = new THREE.DirectionalLight(0xffffff, 1.25);
    key.position.set(0.7, -1.2, 1.4);
    scene.add(ambient, key);
    const galaxyBackground = this.addAssociationXyzGalaxyBackground(scene);

    const root = new THREE.Group();
    scene.add(root);
    this.addAssociationXyzReferenceObjects(root, bounds, parsedRows);
    const renderedIsodensity = modelComponents.length > 0 && this.addAssociationXyzIsodensityModel(root, modelComponents);
    if (!renderedIsodensity && models.length > 0) this.addAssociationXyzModel(root, models[0], bounds);
    this.addAssociationXyzPoints(root, parsedRows, bounds);

    const distance = Math.max(80, bounds.radius * 2.1);
    const direction = new THREE.Vector3(1.25, -1.55, 0.9).normalize();
    camera.position.copy(direction.multiplyScalar(distance));
    camera.near = Math.max(0.01, distance / 20000);
    camera.far = Math.max(20000, distance * 80);
    camera.updateProjectionMatrix();

    const controls = new THREE.OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true;
    controls.dampingFactor = 0.075;
    controls.enablePan = false;
    controls.enableRotate = true;
    controls.enableZoom = true;
    controls.rotateSpeed = 0.48;
    controls.zoomSpeed = 1.08;
    controls.screenSpacePanning = true;
    controls.minDistance = Math.max(0.25, bounds.radius * 0.006);
    controls.maxDistance = Math.max(20000, bounds.radius * 50);
    if (THREE.MOUSE) {
      controls.mouseButtons = {
        LEFT: THREE.MOUSE.ROTATE,
        MIDDLE: THREE.MOUSE.DOLLY,
        RIGHT: THREE.MOUSE.ROTATE,
      };
    }
    if (THREE.TOUCH) {
      controls.touches = {
        ONE: THREE.TOUCH.ROTATE,
        TWO: THREE.TOUCH.DOLLY_PAN,
      };
    }
    if ("zoomToCursor" in controls) controls.zoomToCursor = false;
    controls.target.set(0, 0, 0);
    controls.update();

    const sceneState = {
      renderer,
      scene,
      camera,
      controls,
      galaxyBackground,
      bounds,
      container,
      animationId: null,
      resizeObserver: null,
      eventListeners: [],
    };
    this.associationXyzScene = sceneState;
    this.setupAssociationSceneZoomLock(sceneState, "#moca-xyz-zoom-lock-toggle", "XYZ");

    const addListener = (target, type, handler, options) => {
      target.addEventListener(type, handler, options);
      sceneState.eventListeners.push([target, type, handler, options]);
    };

    const onDoubleClick = () => {
      const nextDistance = Math.max(80, bounds.radius * 2.1);
      const nextDirection = camera.position.clone().sub(controls.target).normalize();
      const cameraDirection = nextDirection.lengthSq() > 1e-8 ? nextDirection : new THREE.Vector3(1.25, -1.55, 0.9).normalize();
      controls.target.set(0, 0, 0);
      camera.position.copy(cameraDirection.multiplyScalar(nextDistance));
      controls.update();
    };

    addListener(container, "dblclick", onDoubleClick);
    addListener(renderer.domElement, "contextmenu", (event) => event.preventDefault());

    const resizeScene = () => {
      const nextWidth = Math.max(320, container.clientWidth || 320);
      const nextHeight = Math.max(320, container.clientHeight || 380);
      camera.aspect = nextWidth / nextHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(nextWidth, nextHeight);
    };
    if (window.ResizeObserver) {
      sceneState.resizeObserver = new ResizeObserver(resizeScene);
      sceneState.resizeObserver.observe(container);
    } else {
      addListener(window, "resize", resizeScene);
    }

    const animate = () => {
      controls.update();
      this.updateAssociationXyzGalaxyBackground(sceneState);
      renderer.render(scene, camera);
      sceneState.animationId = window.requestAnimationFrame(animate);
    };
    animate();

    const goodCount = parsedRows.filter((row) => this.associationXyzIsGoodBanyan(row)).length;
    const modelText = renderedIsodensity
      ? "latest BANYAN Σ model shown as isodensity contours"
      : (models.length ? "latest BANYAN Σ model shown as a 2-sigma ellipsoid" : "no latest BANYAN Σ model available");
    this.setAssociationXyzStatus(`${parsedRows.length.toLocaleString()} members plotted`, "ready");
    $("#moca-xyz-summary").text(`${mocaAid}: ${parsedRows.length.toLocaleString()} propagated BF/HM/CM/LM members in XYZ, ${goodCount.toLocaleString()} with latest BANYAN >=90%; ${modelText}.`);
    this.setAssociationXyzLoading(false);
  }

  renderAssociationUvw(rows, mocaAid, modelRows = [], modelComponentRows = []) {
    const container = document.getElementById("moca-uvw-scene");
    if (!container || !window.THREE) {
      this.setAssociationUvwStatus("Three.js unavailable", "error");
      this.setAssociationUvwLoading(false);
      return;
    }

    const parsedRows = rows.map((row) => {
      return {
        ...row,
        x: this.numericOrNull(row.u_kms),
        y: this.numericOrNull(row.v_kms),
        z: this.numericOrNull(row.w_kms),
        sptn: this.numericOrNull(row.sptn),
        banyan_prob: this.numericOrNull(row.banyan_prob),
        banyan_uvw_sep_kms: this.numericOrNull(row.banyan_uvw_sep_kms),
        latest_bsigma_prob: this.numericOrNull(row.latest_bsigma_prob),
        latest_bsigma_uvw_sep: this.numericOrNull(row.latest_bsigma_uvw_sep),
        moca_bsmdid: this.numericOrNull(row.moca_bsmdid),
      };
    }).filter((row) => row.x !== null && row.y !== null && row.z !== null);

    const models = modelRows.map((row) => {
      return {
        ...row,
        cx: this.numericOrNull(row.avg_u_kms),
        cy: this.numericOrNull(row.avg_v_kms),
        cz: this.numericOrNull(row.avg_w_kms),
        sx: this.numericOrNull(row.u_stddev),
        sy: this.numericOrNull(row.v_stddev),
        sz: this.numericOrNull(row.w_stddev),
        moca_bsmdid: this.numericOrNull(row.moca_bsmdid),
      };
    }).filter((row) => row.cx !== null && row.cy !== null && row.cz !== null
      && row.sx !== null && row.sy !== null && row.sz !== null
      && row.sx > 0 && row.sy > 0 && row.sz > 0);
    const modelComponents = this.parseAssociationUvwModelComponents(modelComponentRows);

    this.associationUvwRows = parsedRows;
    this.disposeAssociationUvwScene();

    if (parsedRows.length == 0 && models.length == 0) {
      this.setAssociationUvwStatus("No UVW rows", "error");
      this.setAssociationUvwLoading(false);
      $("#moca-uvw-summary").text("No propagated members with UVW velocities were found.");
      return;
    }

    const THREE = window.THREE;
    const bounds = this.associationXyzBounds(parsedRows, models, modelComponents);
    const width = Math.max(320, container.clientWidth || container.getBoundingClientRect().width || 320);
    const height = Math.max(320, container.clientHeight || 380);
    const scene = new THREE.Scene();
    scene.background = new THREE.Color("#08090c");
    const camera = new THREE.PerspectiveCamera(42, width / height, 0.01, Math.max(20000, bounds.radius * 80));
    camera.up.set(0, 0, 1);
    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: false, powerPreference: "high-performance" });

    renderer.setClearColor(0x08090c, 1);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    if ("outputEncoding" in renderer && THREE.sRGBEncoding) renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.setSize(width, height);
    container.innerHTML = "";
    container.appendChild(renderer.domElement);

    const ambient = new THREE.AmbientLight(0xffffff, 0.62);
    const key = new THREE.DirectionalLight(0xffffff, 1.25);
    key.position.set(0.7, -1.2, 1.4);
    scene.add(ambient, key);

    const root = new THREE.Group();
    scene.add(root);
    this.addAssociationXyzReferenceObjects(root, bounds, parsedRows, {
      axisLabels: ["U", "V", "W"],
      centerLabel: "0",
      distanceUnit: "km/s",
      zAxisScale: 1,
      includeZReference: true,
      majorRadii: [10, 20, 50, 100],
      minorStep: 10,
      minorStart: 10,
    });
    const renderedIsodensity = modelComponents.length > 0 && this.addAssociationXyzIsodensityModel(root, modelComponents);
    if (!renderedIsodensity && models.length > 0) this.addAssociationXyzModel(root, models[0], bounds);
    this.addAssociationXyzPoints(root, parsedRows, bounds);

    const distance = Math.max(80, bounds.radius * 2.1);
    const direction = new THREE.Vector3(1.25, -1.55, 0.9).normalize();
    camera.position.copy(direction.multiplyScalar(distance));
    camera.near = Math.max(0.01, distance / 20000);
    camera.far = Math.max(20000, distance * 80);
    camera.updateProjectionMatrix();

    const controls = new THREE.OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true;
    controls.dampingFactor = 0.075;
    controls.enablePan = false;
    controls.enableRotate = true;
    controls.enableZoom = true;
    controls.rotateSpeed = 0.48;
    controls.zoomSpeed = 1.08;
    controls.screenSpacePanning = true;
    controls.minDistance = Math.max(0.25, bounds.radius * 0.006);
    controls.maxDistance = Math.max(20000, bounds.radius * 50);
    if (THREE.MOUSE) {
      controls.mouseButtons = {
        LEFT: THREE.MOUSE.ROTATE,
        MIDDLE: THREE.MOUSE.DOLLY,
        RIGHT: THREE.MOUSE.ROTATE,
      };
    }
    if (THREE.TOUCH) {
      controls.touches = {
        ONE: THREE.TOUCH.ROTATE,
        TWO: THREE.TOUCH.DOLLY_PAN,
      };
    }
    if ("zoomToCursor" in controls) controls.zoomToCursor = false;
    controls.target.set(0, 0, 0);
    controls.update();

    const sceneState = {
      renderer,
      scene,
      camera,
      controls,
      bounds,
      container,
      animationId: null,
      resizeObserver: null,
      eventListeners: [],
    };
    this.associationUvwScene = sceneState;
    this.setupAssociationSceneZoomLock(sceneState, "#moca-uvw-zoom-lock-toggle", "UVW");

    const addListener = (target, type, handler, options) => {
      target.addEventListener(type, handler, options);
      sceneState.eventListeners.push([target, type, handler, options]);
    };

    const onDoubleClick = () => {
      const nextDistance = Math.max(80, bounds.radius * 2.1);
      const nextDirection = camera.position.clone().sub(controls.target).normalize();
      const cameraDirection = nextDirection.lengthSq() > 1e-8 ? nextDirection : new THREE.Vector3(1.25, -1.55, 0.9).normalize();
      controls.target.set(0, 0, 0);
      camera.position.copy(cameraDirection.multiplyScalar(nextDistance));
      controls.update();
    };

    addListener(container, "dblclick", onDoubleClick);
    addListener(renderer.domElement, "contextmenu", (event) => event.preventDefault());

    const resizeScene = () => {
      const nextWidth = Math.max(320, container.clientWidth || 320);
      const nextHeight = Math.max(320, container.clientHeight || 380);
      camera.aspect = nextWidth / nextHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(nextWidth, nextHeight);
    };
    if (window.ResizeObserver) {
      sceneState.resizeObserver = new ResizeObserver(resizeScene);
      sceneState.resizeObserver.observe(container);
    } else {
      addListener(window, "resize", resizeScene);
    }

    const animate = () => {
      controls.update();
      renderer.render(scene, camera);
      sceneState.animationId = window.requestAnimationFrame(animate);
    };
    animate();

    const goodCount = parsedRows.filter((row) => this.associationXyzIsGoodBanyan(row)).length;
    const modelText = renderedIsodensity
      ? "latest BANYAN Σ model shown as isodensity contours"
      : (models.length ? "latest BANYAN Σ model shown as a 2-sigma ellipsoid" : "no latest BANYAN Σ model available");
    this.setAssociationUvwStatus(`${parsedRows.length.toLocaleString()} members plotted`, "ready");
    $("#moca-uvw-summary").text(`${mocaAid}: ${parsedRows.length.toLocaleString()} propagated BF/HM/CM/LM members in UVW, ${goodCount.toLocaleString()} with latest BANYAN >=90%; ${modelText}.`);
    this.setAssociationUvwLoading(false);
  }

  disposeAssociationXyzScene() {
    const state = this.associationXyzScene;
    if (!state) return;

    if (state.animationId) window.cancelAnimationFrame(state.animationId);
    this.resetAssociationSceneZoomLock(state);
    if (state.resizeObserver) state.resizeObserver.disconnect();
    if (state.controls?.dispose) state.controls.dispose();
    (state.eventListeners || []).forEach(([target, type, handler, options]) => {
      target.removeEventListener(type, handler, options);
    });
    if (state.scene) {
      state.scene.traverse((object) => {
        if (object.geometry) object.geometry.dispose();
        if (object.material) {
          const materials = Array.isArray(object.material) ? object.material : [object.material];
          materials.forEach((material) => {
            if (material.map) material.map.dispose();
            material.dispose();
          });
        }
      });
      (state.galaxyBackground?.textures || []).forEach((texture) => texture.dispose());
      state.scene.background = null;
    }
    if (state.renderer) {
      state.renderer.dispose();
      if (state.renderer.forceContextLoss) state.renderer.forceContextLoss();
    }
    if (state.container) {
      state.container.classList.remove("is-dragging");
      state.container.innerHTML = "";
    }
    this.associationXyzScene = null;
  }

  disposeAssociationUvwScene() {
    const state = this.associationUvwScene;
    if (!state) return;

    if (state.animationId) window.cancelAnimationFrame(state.animationId);
    this.resetAssociationSceneZoomLock(state);
    if (state.resizeObserver) state.resizeObserver.disconnect();
    if (state.controls?.dispose) state.controls.dispose();
    (state.eventListeners || []).forEach(([target, type, handler, options]) => {
      target.removeEventListener(type, handler, options);
    });
    if (state.scene) {
      state.scene.traverse((object) => {
        if (object.geometry) object.geometry.dispose();
        if (object.material) {
          const materials = Array.isArray(object.material) ? object.material : [object.material];
          materials.forEach((material) => {
            if (material.map) material.map.dispose();
            material.dispose();
          });
        }
      });
      state.scene.background = null;
    }
    if (state.renderer) {
      state.renderer.dispose();
      if (state.renderer.forceContextLoss) state.renderer.forceContextLoss();
    }
    if (state.container) {
      state.container.classList.remove("is-dragging");
      state.container.innerHTML = "";
    }
    this.associationUvwScene = null;
  }

  parseAssociationXyzModelComponents(rows) {
    return rows.map((row) => {
      const mean = [
        this.numericOrNull(row.x_cen),
        this.numericOrNull(row.y_cen),
        this.numericOrNull(row.z_cen),
      ];
      const covariance = [
        [this.numericOrNull(row.xx_covar), this.numericOrNull(row.xy_covar), this.numericOrNull(row.xz_covar)],
        [this.numericOrNull(row.xy_covar), this.numericOrNull(row.yy_covar), this.numericOrNull(row.yz_covar)],
        [this.numericOrNull(row.xz_covar), this.numericOrNull(row.yz_covar), this.numericOrNull(row.zz_covar)],
      ];
      const determinant = this.matrix3Determinant(covariance);
      const inverse = this.matrix3Inverse(covariance);
      const weight = this.numericOrNull(row.coeff_amplitude);
      return {
        ...row,
        mean,
        covariance,
        determinant,
        inverse,
        weight: weight !== null && weight > 0 ? weight : 1,
        sigma: [
          Math.sqrt(Math.max(covariance[0][0] || 0, 1e-12)),
          Math.sqrt(Math.max(covariance[1][1] || 0, 1e-12)),
          Math.sqrt(Math.max(covariance[2][2] || 0, 1e-12)),
        ],
      };
    }).filter((component) => {
      return component.mean.every((value) => value !== null)
        && component.covariance.every((row) => row.every((value) => value !== null))
        && Number.isFinite(component.determinant)
        && component.determinant > 0
        && component.inverse !== null;
    });
  }

  parseAssociationUvwModelComponents(rows) {
    return rows.map((row) => {
      const mean = [
        this.numericOrNull(row.u_cen),
        this.numericOrNull(row.v_cen),
        this.numericOrNull(row.w_cen),
      ];
      const covariance = [
        [this.numericOrNull(row.uu_covar), this.numericOrNull(row.uv_covar), this.numericOrNull(row.uw_covar)],
        [this.numericOrNull(row.uv_covar), this.numericOrNull(row.vv_covar), this.numericOrNull(row.vw_covar)],
        [this.numericOrNull(row.uw_covar), this.numericOrNull(row.vw_covar), this.numericOrNull(row.ww_covar)],
      ];
      const determinant = this.matrix3Determinant(covariance);
      const inverse = this.matrix3Inverse(covariance);
      const weight = this.numericOrNull(row.coeff_amplitude);
      return {
        ...row,
        mean,
        covariance,
        determinant,
        inverse,
        weight: weight !== null && weight > 0 ? weight : 1,
        sigma: [
          Math.sqrt(Math.max(covariance[0][0] || 0, 1e-12)),
          Math.sqrt(Math.max(covariance[1][1] || 0, 1e-12)),
          Math.sqrt(Math.max(covariance[2][2] || 0, 1e-12)),
        ],
      };
    }).filter((component) => {
      return component.mean.every((value) => value !== null)
        && component.covariance.every((row) => row.every((value) => value !== null))
        && Number.isFinite(component.determinant)
        && component.determinant > 0
        && component.inverse !== null;
    });
  }

  associationXyzBounds(rows, models, modelComponents = []) {
    const xs = [0];
    const ys = [0];
    const zs = [0];
    rows.forEach((row) => {
      xs.push(row.x);
      ys.push(row.y);
      zs.push(row.z);
    });
    models.forEach((model) => {
      const scale = 2;
      xs.push(model.cx - scale * model.sx, model.cx + scale * model.sx);
      ys.push(model.cy - scale * model.sy, model.cy + scale * model.sy);
      zs.push(model.cz - scale * model.sz, model.cz + scale * model.sz);
    });
    modelComponents.forEach((component) => {
      const scale = 5;
      xs.push(component.mean[0] - scale * component.sigma[0], component.mean[0] + scale * component.sigma[0]);
      ys.push(component.mean[1] - scale * component.sigma[1], component.mean[1] + scale * component.sigma[1]);
      zs.push(component.mean[2] - scale * component.sigma[2], component.mean[2] + scale * component.sigma[2]);
    });
    const finite = (values) => values.filter((value) => Number.isFinite(value));
    const xvals = finite(xs);
    const yvals = finite(ys);
    const zvals = finite(zs);
    const min = [Math.min(...xvals), Math.min(...yvals), Math.min(...zvals)];
    const max = [Math.max(...xvals), Math.max(...yvals), Math.max(...zvals)];
    const center = [
      (min[0] + max[0]) / 2,
      (min[1] + max[1]) / 2,
      (min[2] + max[2]) / 2,
    ];
    const radius = Math.max(10, (Math.max(max[0] - min[0], max[1] - min[1], max[2] - min[2]) || 10) * 0.62);
    return { min, max, center, radius };
  }

  addAssociationXyzGalaxyBackground(scene) {
    const THREE = window.THREE;
    const loader = new THREE.TextureLoader();
    if (loader.setCrossOrigin) loader.setCrossOrigin("anonymous");
    const textures = [];
    const geometry = new THREE.SphereGeometry(1, 96, 48);
    const material = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      side: THREE.BackSide,
      depthTest: false,
      depthWrite: false,
    });
    const mesh = new THREE.Mesh(geometry, material);
    mesh.visible = false;
    mesh.frustumCulled = false;
    mesh.renderOrder = -10000;
    mesh.raycast = () => {};
    scene.add(mesh);

    const configureTexture = (texture) => {
      if ("encoding" in texture && THREE.sRGBEncoding) texture.encoding = THREE.sRGBEncoding;
      if ("colorSpace" in texture && THREE.SRGBColorSpace) texture.colorSpace = THREE.SRGBColorSpace;
      texture.wrapS = THREE.ClampToEdgeWrapping;
      texture.wrapT = THREE.ClampToEdgeWrapping;
      texture.minFilter = THREE.LinearFilter;
      texture.magFilter = THREE.LinearFilter;
      texture.generateMipmaps = false;
    };
    const loadTexture = (url, fallbackUrl = null) => {
      const texture = loader.load(
        url,
        (loadedTexture) => {
          configureTexture(loadedTexture);
          loadedTexture.needsUpdate = true;
          material.map = loadedTexture;
          material.needsUpdate = true;
          mesh.visible = true;
        },
        undefined,
        (error) => {
          if (fallbackUrl) {
            loadTexture(fallbackUrl);
          } else {
            console.warn(`Unable to load XYZ Galaxy background image at ${url}`, error);
          }
        },
      );
      configureTexture(texture);
      textures.push(texture);
      return texture;
    };
    loadTexture(
      "/images/eso0932a.jpg",
      "https://cdn.eso.org/images/large/eso0932a.jpg",
    );
    return { mesh, textures };
  }

  updateAssociationXyzGalaxyBackground(state) {
    const mesh = state?.galaxyBackground?.mesh;
    if (!mesh || !state.camera || !state.controls) return;
    const viewDistance = state.camera.position.distanceTo(state.controls.target);
    const radius = Math.min(state.camera.far * 0.42, Math.max(4500, viewDistance * 6));
    mesh.position.copy(state.camera.position);
    mesh.rotation.set(Math.PI / 2, 0, 0);
    mesh.scale.setScalar(radius);
  }

  addAssociationXyzReferenceObjects(parent, bounds, rows, options = {}) {
    const THREE = window.THREE;
    const referenceRadius = this.associationXyzReferenceRadius(rows, Boolean(options.includeZReference));
    this.addAssociationXyzSun(parent, bounds, referenceRadius, options.centerLabel || "Sun");
    this.addAssociationXyzReferencePlane(parent, referenceRadius);
    this.addAssociationXyzReferenceGuides(parent, referenceRadius, options.axisLabels || ["X", "Y", "Z"], options.zAxisScale ?? 0.25);

    const referenceRadii = this.associationXyzReferenceRadii(referenceRadius, options);
    referenceRadii.minor.forEach((radius) => this.addAssociationXyzReferenceCircle(parent, radius, false, options.distanceUnit || "pc"));
    referenceRadii.major.forEach((radius) => this.addAssociationXyzReferenceCircle(parent, radius, true, options.distanceUnit || "pc"));
  }

  associationXyzReferenceRadius(rows, includeZ = false) {
    const radii = rows.map((row) => {
      if (includeZ) return Math.max(Math.abs(row.x || 0), Math.abs(row.y || 0), Math.abs(row.z || 0));
      return Math.hypot(row.x || 0, row.y || 0);
    }).filter((value) => Number.isFinite(value));
    if (!radii.length) return 1000;
    return Math.max(10, Math.max(...radii));
  }

  addAssociationXyzSun(parent, bounds, referenceRadius, labelText = "Sun") {
    const THREE = window.THREE;
    const color = "#00a8ff";
    const extent = Math.max(6, Math.min(18, referenceRadius * 0.018));
    const tubeRadius = Math.max(0.35, Math.min(1.5, extent * 0.108));
    [0, 1, 2].forEach((axisIndex) => {
      const start = new THREE.Vector3(0, 0, 0);
      const end = new THREE.Vector3(0, 0, 0);
      start.setComponent(axisIndex, -extent);
      end.setComponent(axisIndex, extent);
      parent.add(this.associationXyzTubeFromPoints([start, end], color, tubeRadius, 1, false, 8));
    });
    const label = this.associationXyzTextSprite(labelText, color, Math.max(2, bounds.radius * 0.0275), true);
    label.position.set(0, 0, -Math.max(5, bounds.radius * 0.045));
    parent.add(label);
  }

  addAssociationXyzReferencePlane(parent, radius) {
    const THREE = window.THREE;
    const segments = 144;
    const positions = [0, 0, 0];
    for (let index = 0; index < segments; index += 1) {
      const angle = 2 * Math.PI * index / segments;
      positions.push(Math.cos(angle) * radius, Math.sin(angle) * radius, 0);
    }
    const indices = [];
    for (let index = 0; index < segments; index += 1) {
      indices.push(0, index + 1, index === segments - 1 ? 1 : index + 2);
    }
    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute("position", new THREE.Float32BufferAttribute(positions, 3));
    geometry.setIndex(indices);
    geometry.computeVertexNormals();
    const material = new THREE.MeshBasicMaterial({
      color: 0x73c9ff,
      transparent: true,
      opacity: 0.12,
      side: THREE.DoubleSide,
      depthWrite: false,
    });
    parent.add(new THREE.Mesh(geometry, material));
  }

  addAssociationXyzReferenceGuides(parent, radius, axisLabels = ["X", "Y", "Z"], zAxisScale = 0.25) {
    const THREE = window.THREE;
    const color = "#00a8ff";
    const tubeRadius = Math.max(0.75, Math.min(4.2, radius * 0.004));
    const guides = [
      { label: axisLabels[0] || "X", end: new THREE.Vector3(radius, 0, 0) },
      { label: axisLabels[1] || "Y", end: new THREE.Vector3(0, radius, 0) },
      { label: axisLabels[2] || "Z", end: new THREE.Vector3(0, 0, radius * zAxisScale) },
    ];
    guides.forEach((guide) => {
      parent.add(this.associationXyzTubeFromPoints([new THREE.Vector3(0, 0, 0), guide.end], color, tubeRadius, 0.22, false, 10));
      const label = this.associationXyzTextSprite(guide.label, color, Math.max(4, radius * 0.045), true);
      label.position.copy(guide.end);
      parent.add(label);
    });
  }

  addAssociationXyzReferenceCircle(parent, radius, major, unit = "pc") {
    const THREE = window.THREE;
    const tubeRadius = Math.max(0.45, Math.min(3.4, radius * (major ? 0.0042 : 0.0024)));
    const segments = 192;
    const points = [];
    for (let index = 0; index < segments; index += 1) {
      const angle = 2 * Math.PI * index / segments;
      points.push(new THREE.Vector3(Math.cos(angle) * radius, Math.sin(angle) * radius, 0));
    }
    parent.add(this.associationXyzTubeFromPoints(points, "#00a8ff", tubeRadius, major ? 0.24 : 0.08, true, 8));
    if (major) {
      const label = this.associationXyzTextSprite(`${radius} ${unit}`, "#00a8ff", Math.max(4, radius * 0.08), true);
      label.position.set(0, -radius, 0);
      parent.add(label);
    }
  }

  associationXyzReferenceRadii(radius, options = {}) {
    const majorCandidates = options.majorRadii || [10, 100, 1000];
    const major = majorCandidates.filter((value) => value <= radius + 1e-9);
    const majorSet = new Set(majorCandidates);
    const minorStep = options.minorStep || 100;
    const maxMinor = Math.floor((Number(radius) + 1e-9) / minorStep) * minorStep;
    const minorStart = options.minorStart || 200;
    const minor = [];
    for (let value = minorStart; value <= maxMinor; value += minorStep) {
      if (!majorSet.has(value)) minor.push(value);
    }
    if (!major.length) major.push(10);
    return { major, minor };
  }

  associationXyzTubeFromPoints(points, color, radius, opacity = 1, closed = false, radialSegments = 8) {
    const THREE = window.THREE;
    const cleanPoints = points.filter((point) => point && Number.isFinite(point.x) && Number.isFinite(point.y) && Number.isFinite(point.z));
    if (cleanPoints.length < 2) return new THREE.Group();
    const curve = cleanPoints.length === 2
      ? new THREE.LineCurve3(cleanPoints[0], cleanPoints[1])
      : new THREE.CatmullRomCurve3(cleanPoints, closed, "catmullrom", 0.5);
    const geometry = new THREE.TubeGeometry(
      curve,
      Math.max(1, closed ? cleanPoints.length : cleanPoints.length - 1),
      radius,
      radialSegments,
      closed,
    );
    const material = new THREE.MeshBasicMaterial({
      color,
      transparent: opacity < 1,
      opacity,
      depthWrite: opacity >= 1,
    });
    return new THREE.Mesh(geometry, material);
  }

  addAssociationXyzPoints(parent, rows, bounds) {
    const regularRows = rows.filter((row) => !this.associationXyzIsGoodBanyan(row));
    const goodRows = rows.filter((row) => this.associationXyzIsGoodBanyan(row));
    this.addAssociationXyzSphereCloud(parent, regularRows, bounds, 0xe52638, 0.58, 1);
    this.addAssociationXyzSphereCloud(parent, goodRows, bounds, 0xffea00, 0.82, 1.35);
  }

  addAssociationXyzSphereCloud(parent, rows, bounds, color, opacity, radiusScale) {
    if (!rows.length) return;
    const THREE = window.THREE;
    const radius = Math.max(0.385, Math.min(2.065, bounds.radius * 0.00882 * radiusScale));
    const geometry = new THREE.SphereGeometry(radius, 20, 14);
    const material = new THREE.MeshLambertMaterial({
      color,
      transparent: true,
      opacity,
      depthWrite: false,
    });
    const group = new THREE.Group();
    rows.forEach((row, index) => {
      const sphere = new THREE.Mesh(geometry, material);
      sphere.position.set(row.x, row.y, row.z);
      sphere.userData = { row, index };
      group.add(sphere);
    });
    parent.add(group);
  }

  addAssociationXyzIsodensityModel(parent, components) {
    if (!window.THREE?.MarchingCubes || !components.length) return false;
    const surfaceData = this.associationXyzModelSurfaceData(components);
    if (!surfaceData) return false;

    const THREE = window.THREE;
    const contours = [
      { contour: 0.99, opacity: 0.07 },
      { contour: 0.95, opacity: 0.15 },
      { contour: 0.68, opacity: 0.30 },
    ];
    let added = false;

    contours.forEach((entry) => {
      const level = this.associationXyzDensityThreshold(surfaceData.density, entry.contour);
      if (level === null) return;

      const material = new THREE.MeshLambertMaterial({
        color: 0x009e73,
        transparent: true,
        opacity: entry.opacity,
        side: THREE.DoubleSide,
        depthWrite: false,
      });
      const marchingCubes = new THREE.MarchingCubes(surfaceData.resolution, material, false, false);
      marchingCubes.field.set(surfaceData.density);
      marchingCubes.isolation = level;
      const geometry = marchingCubes.generateGeometry();
      if (!geometry || !geometry.attributes?.position?.count) {
        geometry?.dispose?.();
        return;
      }
      geometry.computeVertexNormals();
      const mesh = new THREE.Mesh(geometry, material);
      mesh.position.set(
        (surfaceData.lower[0] + surfaceData.upper[0]) / 2,
        (surfaceData.lower[1] + surfaceData.upper[1]) / 2,
        (surfaceData.lower[2] + surfaceData.upper[2]) / 2,
      );
      mesh.scale.set(
        (surfaceData.upper[0] - surfaceData.lower[0]) / 2,
        (surfaceData.upper[1] - surfaceData.lower[1]) / 2,
        (surfaceData.upper[2] - surfaceData.lower[2]) / 2,
      );
      parent.add(mesh);
      added = true;
    });

    return added;
  }

  associationXyzModelSurfaceData(components) {
    const resolution = 56;
    const lower = [Infinity, Infinity, Infinity];
    const upper = [-Infinity, -Infinity, -Infinity];
    components.forEach((component) => {
      for (let axis = 0; axis < 3; axis += 1) {
        lower[axis] = Math.min(lower[axis], component.mean[axis] - 5 * component.sigma[axis]);
        upper[axis] = Math.max(upper[axis], component.mean[axis] + 5 * component.sigma[axis]);
      }
    });
    if (!lower.every(Number.isFinite) || !upper.every(Number.isFinite) || upper.some((value, index) => value <= lower[index])) {
      return null;
    }

    const density = new Float32Array(resolution * resolution * resolution);
    const step = [
      (upper[0] - lower[0]) / (resolution - 1),
      (upper[1] - lower[1]) / (resolution - 1),
      (upper[2] - lower[2]) / (resolution - 1),
    ];
    const normalizations = components.map((component) => {
      return component.weight / (((2 * Math.PI) ** 1.5) * Math.sqrt(component.determinant));
    });

    let index = 0;
    for (let zIndex = 0; zIndex < resolution; zIndex += 1) {
      const z = lower[2] + step[2] * zIndex;
      for (let yIndex = 0; yIndex < resolution; yIndex += 1) {
        const y = lower[1] + step[1] * yIndex;
        for (let xIndex = 0; xIndex < resolution; xIndex += 1) {
          const x = lower[0] + step[0] * xIndex;
          let value = 0;
          components.forEach((component, componentIndex) => {
            const dx = x - component.mean[0];
            const dy = y - component.mean[1];
            const dz = z - component.mean[2];
            const inverse = component.inverse;
            const q =
              dx * (inverse[0][0] * dx + inverse[0][1] * dy + inverse[0][2] * dz) +
              dy * (inverse[1][0] * dx + inverse[1][1] * dy + inverse[1][2] * dz) +
              dz * (inverse[2][0] * dx + inverse[2][1] * dy + inverse[2][2] * dz);
            if (Number.isFinite(q)) value += normalizations[componentIndex] * Math.exp(-0.5 * Math.min(Math.max(q, 0), 200));
          });
          density[index] = value;
          index += 1;
        }
      }
    }

    return { density, resolution, lower, upper };
  }

  associationXyzDensityThreshold(density, contour) {
    const sortedDensity = [];
    for (let index = 0; index < density.length; index += 1) {
      const value = density[index];
      if (Number.isFinite(value) && value > 0) sortedDensity.push(value);
    }
    if (!sortedDensity.length) return null;
    sortedDensity.sort((a, b) => b - a);
    let total = 0;
    sortedDensity.forEach((value) => { total += value; });
    if (!Number.isFinite(total) || total <= 0) return null;

    let cumulative = 0;
    let level = sortedDensity[sortedDensity.length - 1];
    for (let index = 0; index < sortedDensity.length; index += 1) {
      cumulative += sortedDensity[index];
      if (cumulative / total >= contour) {
        level = sortedDensity[index];
        break;
      }
    }
    const minValue = sortedDensity[sortedDensity.length - 1];
    const maxValue = sortedDensity[0];
    if (!Number.isFinite(level) || level <= minValue || level >= maxValue) {
      const eps = Math.max((maxValue - minValue) * 1e-6, 1e-300);
      level = Math.min(Math.max(level, minValue + eps), maxValue - eps);
    }
    return Number.isFinite(level) && minValue < level && level < maxValue ? level : null;
  }

  matrix3Determinant(matrix) {
    if (!matrix || matrix.length != 3 || matrix.some((row) => !row || row.length != 3 || row.some((value) => value === null))) {
      return null;
    }
    const a = matrix[0][0], b = matrix[0][1], c = matrix[0][2];
    const d = matrix[1][0], e = matrix[1][1], f = matrix[1][2];
    const g = matrix[2][0], h = matrix[2][1], i = matrix[2][2];
    return a * (e * i - f * h) - b * (d * i - f * g) + c * (d * h - e * g);
  }

  matrix3Inverse(matrix) {
    const determinant = this.matrix3Determinant(matrix);
    if (!Number.isFinite(determinant) || Math.abs(determinant) <= 1e-20) return null;
    const a = matrix[0][0], b = matrix[0][1], c = matrix[0][2];
    const d = matrix[1][0], e = matrix[1][1], f = matrix[1][2];
    const g = matrix[2][0], h = matrix[2][1], i = matrix[2][2];
    const invDet = 1 / determinant;
    return [
      [(e * i - f * h) * invDet, (c * h - b * i) * invDet, (b * f - c * e) * invDet],
      [(f * g - d * i) * invDet, (a * i - c * g) * invDet, (c * d - a * f) * invDet],
      [(d * h - e * g) * invDet, (b * g - a * h) * invDet, (a * e - b * d) * invDet],
    ];
  }

  addAssociationXyzModel(parent, model, bounds) {
    const THREE = window.THREE;
    const sigmaScale = 2;
    const geometry = new THREE.SphereGeometry(1, 64, 32);
    const material = new THREE.MeshLambertMaterial({
      color: 0x009e73,
      transparent: true,
      opacity: 0.16,
      side: THREE.DoubleSide,
      depthWrite: false,
    });
    const ellipsoid = new THREE.Mesh(geometry, material);
    ellipsoid.position.set(model.cx, model.cy, model.cz);
    ellipsoid.scale.set(model.sx * sigmaScale, model.sy * sigmaScale, model.sz * sigmaScale);
    parent.add(ellipsoid);

    const center = new THREE.Mesh(
      new THREE.SphereGeometry(Math.max(0.63, bounds.radius * 0.0126), 20, 14),
      new THREE.MeshLambertMaterial({ color: 0x009e73, transparent: true, opacity: 0.72, depthWrite: false })
    );
    center.position.set(model.cx, model.cy, model.cz);
    parent.add(center);
  }

  associationXyzTextSprite(text, color, size) {
    const THREE = window.THREE;
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const fontSize = 44;
    context.font = `700 ${fontSize}px "Open Sans", Arial, sans-serif`;
    const width = Math.ceil(context.measureText(text).width + 28);
    const height = 70;
    canvas.width = width;
    canvas.height = height;
    context.font = `700 ${fontSize}px "Open Sans", Arial, sans-serif`;
    context.fillStyle = color;
    context.textAlign = "center";
    context.textBaseline = "middle";
    context.fillText(text, width / 2, height / 2 + 1);

    const texture = new THREE.CanvasTexture(canvas);
    const material = new THREE.SpriteMaterial({ map: texture, transparent: true, depthWrite: false });
    const sprite = new THREE.Sprite(material);
    sprite.scale.set((width / height) * size, size, 1);
    return sprite;
  }

  associationXyzIsGoodBanyan(row) {
    const prob = row.latest_bsigma_prob !== null ? row.latest_bsigma_prob : row.banyan_prob;
    return prob !== null && prob >= 90;
  }

  setAssociationXyzStatus(text, mode) {
    const status = $("#moca-xyz-status");
    status.text(text);
    status.toggleClass("loading", mode == "loading");
    status.toggleClass("error", mode == "error");
  }

  setAssociationXyzLoading(visible) {
    $("#moca-xyz-loader").toggleClass("is-visible", Boolean(visible));
  }

  setAssociationUvwStatus(text, mode) {
    const status = $("#moca-uvw-status");
    status.text(text);
    status.toggleClass("loading", mode == "loading");
    status.toggleClass("error", mode == "error");
  }

  setAssociationUvwLoading(visible) {
    $("#moca-uvw-loader").toggleClass("is-visible", Boolean(visible));
  }

  renderAssociationXyzDatavizLink(mocaAid) {
    const wrapper = $("#moca-xyz-wrapper");
    const target = $("#moca-xyz-dataviz");
    if (wrapper.length == 0 || target.length == 0) return;
    const url = this.associationXyzDatavizUrl(mocaAid);
    target.html(`For a richer version, use the <a href="${this.escapeHtml(url)}" target="_blank" rel="noopener">XYZ dataviz page</a>.`).attr("hidden", false);
  }

  renderAssociationUvwDatavizLink(mocaAid) {
    const wrapper = $("#moca-uvw-wrapper");
    const target = $("#moca-uvw-dataviz");
    if (wrapper.length == 0 || target.length == 0) return;
    const url = this.associationUvwDatavizUrl(mocaAid);
    target.html(`For a richer version, use the <a href="${this.escapeHtml(url)}" target="_blank" rel="noopener">UVW dataviz page</a>.`).attr("hidden", false);
  }

  associationXyzDatavizUrl(mocaAid) {
    const base = $("#moca-xyz-wrapper").attr("data-dataviz-url") || "https://dataviz.mocadb.ca/js/xyz";
    try {
      const url = new URL(base, window.location.href);
      url.searchParams.set("axes", "xyz");
      url.searchParams.set("asso", mocaAid);
      url.searchParams.set("checkbox", "models,assmem,likely,subgroups");
      return url.toString();
    } catch (error) {
      const separator = base.indexOf("?") == -1 ? "?" : "&";
      return `${base}${separator}axes=xyz&asso=${encodeURIComponent(mocaAid)}&checkbox=models%2Cassmem%2Clikely%2Csubgroups`;
    }
  }

  associationUvwDatavizUrl(mocaAid) {
    const base = $("#moca-uvw-wrapper").attr("data-dataviz-url") || "https://dataviz.mocadb.ca/js/xyz";
    try {
      const url = new URL(base, window.location.href);
      url.searchParams.set("axes", "uvw");
      url.searchParams.set("asso", mocaAid);
      url.searchParams.set("checkbox", "models,assmem,likely,subgroups");
      return url.toString();
    } catch (error) {
      const separator = base.indexOf("?") == -1 ? "?" : "&";
      return `${base}${separator}axes=uvw&asso=${encodeURIComponent(mocaAid)}&checkbox=models%2Cassmem%2Clikely%2Csubgroups`;
    }
  }

  renderObjectCmd(row, target, fieldRows = [], sequenceRows = []) {
    const parsedObject = {
      ...row,
      x: this.numericOrNull(row.bp_rp),
      y: this.numericOrNull(row.abs_g),
      gmag: this.numericOrNull(row.gmag),
      bpmag: this.numericOrNull(row.bpmag),
      rpmag: this.numericOrNull(row.rpmag),
      dmod: this.numericOrNull(row.dmod),
      parallax_mas: this.numericOrNull(row.parallax_mas),
      dr3_ruwe: this.numericOrNull(row.dr3_ruwe),
      designation: row.object_designation || target.designation || row.gaia_designation || `oid ${row.moca_oid || target.mocaOid}`,
    };

    if (parsedObject.x === null || parsedObject.y === null || !window.Plotly) {
      this.hideObjectCmd();
      return;
    }

    const parsedFieldRows = fieldRows.map((fieldRow) => {
      return {
        ...fieldRow,
        x: this.numericOrNull(fieldRow.bp_rp),
        y: this.numericOrNull(fieldRow.abs_g),
        gmag: this.numericOrNull(fieldRow.gmag),
        bpmag: this.numericOrNull(fieldRow.bpmag),
        rpmag: this.numericOrNull(fieldRow.rpmag),
        parallax_mas: this.numericOrNull(fieldRow.parallax_mas),
        dr3_ruwe: this.numericOrNull(fieldRow.dr3_ruwe),
      }
    }).filter((fieldRow) => fieldRow.x !== null && fieldRow.y !== null);
    const parsedSequences = this.parseAssociationCmdSequences(sequenceRows);

    const traces = [];
    if (parsedFieldRows.length > 0) {
      traces.push(this.associationCmdFieldTrace(parsedFieldRows));
    }
    this.addAssociationCmdSequenceTraces(traces, parsedSequences);
    traces.push(...this.objectCmdTraces(parsedObject));

    const plotElement = document.getElementById("moca-object-cmd-plot");
    if (!plotElement) {
      this.hideObjectCmd();
      return;
    }
    const plotPromise = window.Plotly.react(plotElement, traces, this.objectCmdLayout(parsedObject), this.objectCmdPlotConfig(parsedObject));
    this.bindObjectCmdTargetOverlay(plotElement);
    Promise.resolve(plotPromise).then(() => {
      this.renderObjectCmdTargetOverlay(plotElement, parsedObject);
    });
    this.setObjectCmdStatus("Object plotted", "ready");
    $("#moca-object-cmd-summary").text(`${parsedObject.designation}: Gaia DR3 BP-RP=${parsedObject.x.toFixed(3)}, M_G=${parsedObject.y.toFixed(3)}; ${parsedFieldRows.length.toLocaleString()} Gaia DR3 100 pc field stars, ${parsedSequences.length.toLocaleString()} isochrone overlays.`);
    this.renderObjectCmdDatavizLink(parsedObject.moca_oid || target.mocaOid, target.bestAsso);
    this.setObjectCmdLoading(false);
  }

  objectCmdTraces(row) {
    const baseTrace = {
      type: "scatter",
      mode: "markers",
      legendgroup: "object",
      legendrank: 10000,
      x: [row.x],
      y: [row.y],
      cliponaxis: false,
    };

    return [
      {
        ...baseTrace,
        name: "This object",
        visible: "legendonly",
        showlegend: true,
        hoverinfo: "skip",
        marker: {
          size: 15,
          color: "#d71920",
          opacity: 1,
          symbol: "circle-open",
          line: {
            color: "#d71920",
            width: 3,
          },
        },
      },
      {
        ...baseTrace,
        name: "This object hover anchor",
        showlegend: false,
        text: [this.objectCmdHoverText(row)],
        hovertemplate: "%{text}<extra></extra>",
        marker: {
          size: 30,
          color: "rgba(215, 25, 32, 0.001)",
          opacity: 0.001,
          symbol: "circle",
          line: {
            width: 0,
          },
        },
      },
    ];
  }

  bindObjectCmdTargetOverlay(plotElement) {
    if (!plotElement || plotElement.dataset.mocaObjectCmdTargetOverlayBound == "1") return;
    plotElement.dataset.mocaObjectCmdTargetOverlayBound = "1";

    const update = () => {
      this.updateObjectCmdTargetOverlay(plotElement, plotElement._mocaObjectCmdTargetRow);
    };

    plotElement.on("plotly_afterplot", update);
    plotElement.on("plotly_relayout", update);
    plotElement.on("plotly_restyle", update);
  }

  renderObjectCmdTargetOverlay(plotElement, row) {
    if (!plotElement || !row) return;
    plotElement._mocaObjectCmdTargetRow = row;

    const frame = $(plotElement).closest(".moca-cmd-plot-frame");
    if (frame.length == 0) return;

    let overlay = frame.children(".moca-object-cmd-target-overlay");
    if (overlay.length == 0) {
      overlay = $(`
        <div class="moca-object-cmd-target-overlay" aria-hidden="true" hidden>
          <span class="moca-object-cmd-target-ring outer"></span>
          <span class="moca-object-cmd-target-ring inner"></span>
          <span class="moca-object-cmd-target-dot"></span>
        </div>
      `);
      frame.append(overlay);
    }

    this.updateObjectCmdTargetOverlay(plotElement, row);
    window.requestAnimationFrame(() => {
      this.updateObjectCmdTargetOverlay(plotElement, row);
    });
  }

  updateObjectCmdTargetOverlayForCurrentPlot() {
    const plotElement = document.getElementById("moca-object-cmd-plot");
    if (!plotElement?._mocaObjectCmdTargetRow) return;
    this.updateObjectCmdTargetOverlay(plotElement, plotElement._mocaObjectCmdTargetRow);
  }

  updateObjectCmdTargetOverlay(plotElement, row) {
    const overlay = $(plotElement).closest(".moca-cmd-plot-frame").children(".moca-object-cmd-target-overlay");
    if (overlay.length == 0 || !row) return;

    const fullLayout = plotElement?._fullLayout;
    const xAxis = fullLayout?.xaxis;
    const yAxis = fullLayout?.yaxis;
    if (!xAxis?.l2p || !yAxis?.l2p) {
      overlay.prop("hidden", true);
      return;
    }

    const plotLeft = xAxis._offset ?? fullLayout._size?.l ?? 0;
    const plotTop = yAxis._offset ?? fullLayout._size?.t ?? 0;
    const plotWidth = xAxis._length ?? fullLayout._size?.w ?? plotElement.clientWidth ?? 0;
    const plotHeight = yAxis._length ?? fullLayout._size?.h ?? plotElement.clientHeight ?? 0;
    const left = xAxis.l2p(row.x) + plotLeft;
    const top = yAxis.l2p(row.y) + plotTop;
    const plotRight = plotLeft + plotWidth;
    const plotBottom = plotTop + plotHeight;
    const padding = 18;

    if (!Number.isFinite(left) || !Number.isFinite(top)
      || left < plotLeft - padding || left > plotRight + padding
      || top < plotTop - padding || top > plotBottom + padding) {
      overlay.prop("hidden", true);
      return;
    }

    overlay.css({
      left: `${left}px`,
      top: `${top}px`,
    }).prop("hidden", false);
  }

  objectCmdHoverText(row) {
    return [
      `<b>${this.escapeHtml(row.designation || `oid ${row.moca_oid}`)}</b>`,
      `moca_oid: ${this.escapeHtml(row.moca_oid)}`,
      row.source_id ? `Gaia DR3 source_id: ${this.escapeHtml(row.source_id)}` : null,
      row.dr3_ruwe !== null ? `RUWE: ${row.dr3_ruwe.toFixed(3)}` : null,
      `G_BP - G_RP: ${row.x.toFixed(3)}`,
      `M_G: ${row.y.toFixed(3)}`,
    ].filter(Boolean).join("<br>");
  }

  objectCmdLayout(row) {
    const layout = this.associationCmdLayout(row.moca_oid || "object");
    layout.dragmode = "zoom";
    delete layout.selectdirection;
    return layout;
  }

  objectCmdPlotConfig(row) {
    const filenameOid = row.moca_oid || "object";
    const config = this.associationCmdPlotConfig(`oid_${filenameOid}`);
    config.toImageButtonOptions.filename = `mocadb_oid_${filenameOid}_gaia_cmd`;
    return config;
  }

  setObjectCmdStatus(text, mode) {
    const status = $("#moca-object-cmd-status");
    status.text(text);
    status.toggleClass("loading", mode == "loading");
    status.toggleClass("error", mode == "error");
  }

  setObjectCmdLoading(visible) {
    $("#moca-object-cmd-loader").toggleClass("is-visible", Boolean(visible));
  }

  renderObjectCmdDatavizLink(mocaOid, bestAsso = "") {
    const wrapper = $("#moca-object-cmd-wrapper");
    const target = $("#moca-object-cmd-dataviz");
    if (wrapper.length == 0 || target.length == 0) return;
    const url = this.objectCmdDatavizUrl(mocaOid, bestAsso);
    target.html(`For a richer exploration of the Gaia CMD, use the <a href="${this.escapeHtml(url)}" target="_blank" rel="noopener">Gaia CMD explorer</a>.`).attr("hidden", false);
  }

  objectCmdDatavizUrl(mocaOid, bestAsso = "") {
    const base = $("#moca-object-cmd-wrapper").attr("data-dataviz-url") || "https://dataviz.mocadb.ca/js/gaia-cmd";
    const asso = this.reportOptionalText(bestAsso);
    try {
      const url = new URL(base, window.location.href);
      url.searchParams.set("moca_oid", mocaOid);
      url.searchParams.set("asso", asso);
      return url.toString();
    } catch (error) {
      const separator = base.indexOf("?") == -1 ? "?" : "&";
      return `${base}${separator}moca_oid=${encodeURIComponent(mocaOid)}&asso=${encodeURIComponent(asso)}`;
    }
  }

  renderAssociationCmd(rows, mocaAid, fieldRows = [], sequenceRows = []) {
    const parsedRows = rows.map((row, index) => {
      return {
        ...row,
        _plotIndex: index,
        x: this.numericOrNull(row.bp_rp),
        y: this.numericOrNull(row.abs_g),
        gmag: this.numericOrNull(row.gmag),
        bpmag: this.numericOrNull(row.bpmag),
        rpmag: this.numericOrNull(row.rpmag),
        dmod: this.numericOrNull(row.dmod),
        parallax_mas: this.numericOrNull(row.parallax_mas),
        dr3_ruwe: this.numericOrNull(row.dr3_ruwe),
        sptn: this.numericOrNull(row.sptn),
        banyan_prob: this.numericOrNull(row.banyan_prob),
        banyan_uvw_sep_kms: this.numericOrNull(row.banyan_uvw_sep_kms),
      }
    }).filter((row) => row.x !== null && row.y !== null)
      .map((row, index) => ({...row, _plotIndex: index}));

    this.associationCmdRows = parsedRows;
    const parsedFieldRows = fieldRows.map((row) => {
      return {
        ...row,
        x: this.numericOrNull(row.bp_rp),
        y: this.numericOrNull(row.abs_g),
        gmag: this.numericOrNull(row.gmag),
        bpmag: this.numericOrNull(row.bpmag),
        rpmag: this.numericOrNull(row.rpmag),
        parallax_mas: this.numericOrNull(row.parallax_mas),
        dr3_ruwe: this.numericOrNull(row.dr3_ruwe),
      }
    }).filter((row) => row.x !== null && row.y !== null);
    const parsedSequences = this.parseAssociationCmdSequences(sequenceRows);

    if (!window.Plotly) {
      this.setAssociationCmdStatus("Plotly unavailable", "error");
      this.setAssociationCmdLoading(false);
      return;
    }

    if (parsedRows.length == 0 && parsedFieldRows.length == 0 && parsedSequences.length == 0) {
      this.setAssociationCmdStatus("No Gaia CMD rows", "error");
      this.setAssociationCmdLoading(false);
      window.Plotly.react("moca-cmd-plot", [], this.associationCmdEmptyLayout(mocaAid), this.associationCmdPlotConfig(mocaAid));
      return;
    }

    const traces = [];
    if (parsedFieldRows.length > 0) {
      traces.push(this.associationCmdFieldTrace(parsedFieldRows));
    }
    const mtidOrder = ["BF", "HM", "CM", "LM"];
    mtidOrder.forEach((mtid) => {
      const traceRows = parsedRows.filter((row) => row.moca_mtid == mtid);
      if (traceRows.length == 0) return;
      traces.push(this.associationCmdTrace(traceRows, mtid));
    });
    this.addAssociationCmdSequenceTraces(traces, parsedSequences);

    const plotElement = document.getElementById("moca-cmd-plot");
    window.Plotly.react(plotElement, traces, this.associationCmdLayout(mocaAid), this.associationCmdPlotConfig(mocaAid));
    this.bindAssociationCmdEvents(plotElement);
    this.renderAssociationCmdSelection([]);
    this.setAssociationCmdStatus(`${parsedRows.length.toLocaleString()} members plotted`, "ready");
    $("#moca-cmd-summary").text(`${mocaAid}: ${parsedRows.length.toLocaleString()} BF/HM/CM/LM members, ${parsedFieldRows.length.toLocaleString()} Gaia DR3 100 pc field stars, ${parsedSequences.length.toLocaleString()} empirical sequence overlays.`);
    this.setAssociationCmdLoading(false);
  }

  associationCmdFieldTrace(rows) {
    return {
      type: "scattergl",
      mode: "markers",
      name: "Field",
      legendgroup: "field",
      x: rows.map((row) => row.x),
      y: rows.map((row) => row.y),
      hoverinfo: "skip",
      marker: {
        size: 4.4,
        color: "#000000",
        opacity: 0.05,
        line: { width: 0, color: "#000000" },
      },
    };
  }

  associationCmdTrace(rows, mtid) {
    const style = this.associationCmdMtidStyle(mtid);

    return {
      type: "scattergl",
      mode: "markers",
      name: style.label,
      legendgroup: mtid,
      x: rows.map((row) => row.x),
      y: rows.map((row) => row.y),
      text: rows.map((row) => this.associationCmdHoverText(row)),
      customdata: rows.map((row) => row._plotIndex),
      hovertemplate: "%{text}<extra></extra>",
      marker: {
        size: style.size,
        color: style.color,
        opacity: style.opacity,
        symbol: style.symbol,
        line: {
          color: style.lineColor,
          width: style.lineWidth,
        },
      },
    };
  }

  associationCmdMtidStyle(mtid) {
    const styles = {
      BF: { label: "BF", color: "#0072b2", opacity: 0.88, size: 7.0, symbol: "circle", lineColor: "#0072b2", lineWidth: 0 },
      HM: { label: "HM", color: "#009e73", opacity: 0.84, size: 6.8, symbol: "circle", lineColor: "#009e73", lineWidth: 0 },
      CM: { label: "CM", color: "#d55e00", opacity: 0.78, size: 6.5, symbol: "circle", lineColor: "#d55e00", lineWidth: 0 },
      LM: { label: "LM", color: "#858a8d", opacity: 0.34, size: 6.1, symbol: "circle-open", lineColor: "#858a8d", lineWidth: 1.1 },
    };

    return styles[mtid] || {
      label: mtid || "Other",
      color: "#6b5b95",
      opacity: 0.66,
      size: 6.2,
      symbol: "circle",
      lineColor: "#6b5b95",
      lineWidth: 0,
    };
  }

  parseAssociationCmdSequences(rows) {
    const bySeqid = new Map();
    rows.forEach((row) => {
      const seqid = String(row.moca_seqid || "");
      const x = this.numericOrNull(row.xdata);
      const y = this.numericOrNull(row.ydata);
      if (!seqid || x === null || y === null) return;
      if (!bySeqid.has(seqid)) {
        bySeqid.set(seqid, {
          moca_seqid: seqid,
          name: row.name || seqid,
          x: [],
          y: [],
          yerror: [],
        });
      }
      const sequence = bySeqid.get(seqid);
      sequence.x.push(x);
      sequence.y.push(y);
      sequence.yerror.push(this.numericOrNull(row.yerror));
    });

    return Array.from(bySeqid.values());
  }

  addAssociationCmdSequenceTraces(traces, sequences) {
    this.orderedAssociationCmdSequences(sequences).forEach((sequence) => {
      const suffix = String(sequence.moca_seqid || "").split("_").pop();
      const style = this.associationCmdSequenceStyle(suffix, sequence);
      traces.push({
        type: "scattergl",
        mode: "lines",
        name: style.label,
        legendgroup: `sequence:${suffix}`,
        legendrank: 500 + style.orderIndex,
        x: sequence.x,
        y: sequence.y,
        hoverinfo: "skip",
        line: {
          width: suffix == "field" ? 2.4 : 2,
          color: style.color,
          dash: suffix == "field" ? "solid" : "dash",
        },
      });
    });
  }

  orderedAssociationCmdSequences(sequences) {
    const bySuffix = new Map();
    const order = this.associationCmdSequenceOrder();
    sequences.forEach((sequence) => {
      const suffix = String(sequence.moca_seqid || "").split("_").pop();
      if (order.indexOf(suffix) != -1 && !bySuffix.has(suffix)) {
        bySuffix.set(suffix, sequence);
      }
    });
    return order.map((suffix) => bySuffix.get(suffix)).filter(Boolean);
  }

  associationCmdSequenceOrder() {
    return ["etac", "twa", "bpmg", "tha", "abdmg", "mel5", "field"];
  }

  associationCmdSequenceStyle(suffix, sequence) {
    const colors = {
      field: "#3f3d46",
      mel5: "#d55e00",
      abdmg: "#0072b2",
      tha: "#009e73",
      bpmg: "#cc79a7",
      twa: "#e69f00",
      etac: "#56b4e9",
    };
    const labels = {
      etac: "η Cha (~7 Myr)",
      twa: "TW Hya (~11 Myr)",
      bpmg: "β Pic (~26 Myr)",
      tha: "Tuc-Hor (~40 Myr)",
      abdmg: "AB Dor (~130 Myr)",
      mel5: "MELANGE-5 (~200 Myr)",
      field: "Field",
    };
    return {
      color: colors[suffix] || "#444444",
      label: labels[suffix] || sequence.name || sequence.moca_seqid || suffix,
      orderIndex: this.associationCmdSequenceOrder().indexOf(suffix),
    };
  }

  associationCmdHoverText(row) {
    return [
      `<b>${this.escapeHtml(row.designation || `oid ${row.moca_oid}`)}</b>`,
      `moca_oid: ${this.escapeHtml(row.moca_oid)}`,
      `membership: ${this.escapeHtml(row.moca_mtid || "")}`,
      row.spectral_type ? `spectral type: ${this.escapeHtml(row.spectral_type)}` : null,
      row.dr3_ruwe !== null ? `RUWE: ${row.dr3_ruwe.toFixed(3)}` : null,
      row.banyan_prob !== null ? `BANYAN prob: ${row.banyan_prob.toFixed(1)}%` : null,
      `G_BP - G_RP: ${row.x.toFixed(3)}`,
      `M_G: ${row.y.toFixed(3)}`,
    ].filter(Boolean).join("<br>");
  }

  associationCmdLayout(mocaAid) {
    return {
      title: {
        text: "Gaia DR3 CMD",
        x: 0.02,
        xanchor: "left",
        font: { size: 15, color: "#252329" },
      },
      paper_bgcolor: "#ffffff",
      plot_bgcolor: "#ffffff",
      font: { family: "\"Open Sans\", sans-serif", size: 12, color: "#252329" },
      margin: { l: 58, r: 16, t: 42, b: 58 },
      dragmode: "select",
      hovermode: "closest",
      xaxis: {
        title: { text: "<i>G</i><sub>BP</sub> - <i>G</i><sub>RP</sub>" },
        zeroline: false,
        gridcolor: "#d7d4dc",
        linecolor: "#b8b5bc",
        ticks: "outside",
        mirror: true,
      },
      yaxis: {
        title: { text: "M<sub><i>G</i></sub>" },
        autorange: "reversed",
        zeroline: false,
        gridcolor: "#d7d4dc",
        linecolor: "#b8b5bc",
        ticks: "outside",
        mirror: true,
      },
      legend: {
        orientation: "h",
        x: 0,
        y: -0.18,
        bgcolor: "rgba(255,255,255,0)",
      },
      selectdirection: "any",
    };
  }

  associationCmdEmptyLayout(mocaAid) {
    const layout = this.associationCmdLayout(mocaAid);
    layout.annotations = [{
      text: "No CMD data available",
      x: 0.5,
      y: 0.5,
      xref: "paper",
      yref: "paper",
      showarrow: false,
      font: { size: 14, color: "#5f5864" },
    }];
    return layout;
  }

  associationCmdPlotConfig(mocaAid) {
    return {
      responsive: true,
      displaylogo: false,
      toImageButtonOptions: {
        filename: `mocadb_${mocaAid}_gaia_cmd`,
        format: "png",
        scale: 2,
      },
    };
  }

  bindAssociationCmdEvents(plotElement) {
    if (!plotElement || plotElement.dataset.mocaCmdBound == "1") return;
    plotElement.dataset.mocaCmdBound = "1";

    plotElement.on("plotly_click", (event) => {
      const row = this.associationCmdRowFromPoint(event?.points?.[0]);
      this.renderAssociationCmdSelection(row ? [row] : []);
    });

    plotElement.on("plotly_selected", (event) => {
      const rows = (event?.points || [])
        .map((point) => this.associationCmdRowFromPoint(point))
        .filter(Boolean);
      this.renderAssociationCmdSelection(this.uniqueAssociationCmdRows(rows));
    });

    plotElement.on("plotly_deselect", () => {
      this.renderAssociationCmdSelection([]);
    });
  }

  associationCmdRowFromPoint(point) {
    if (!point) return null;
    return this.associationCmdRows[Number(point.customdata)] || null;
  }

  uniqueAssociationCmdRows(rows) {
    const seen = new Set();
    return rows.filter((row) => {
      const key = String(row.moca_oid);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  renderAssociationCmdSelection(rows) {
    const selection = $("#moca-cmd-selection");
    if (selection.length == 0) return;
    if (!rows.length) {
      selection.attr("hidden", true).empty();
      return;
    }

    const tableRows = rows.slice(0, 30).map((row) => {
      const url = `/search/results?search-query=oid(${encodeURIComponent(row.moca_oid)})&search-type=star`;
      return `<tr>
        <td><a href="${url}">${this.escapeHtml(row.designation || row.moca_oid)}</a></td>
        <td>${this.escapeHtml(row.moca_mtid || "")}</td>
        <td>${Number.isFinite(row.x) ? row.x.toFixed(3) : ""}</td>
        <td>${Number.isFinite(row.y) ? row.y.toFixed(3) : ""}</td>
      </tr>`;
    }).join("");

    selection.html(`
      <div class="moca-cmd-selection-title">${rows.length.toLocaleString()} selected</div>
      <table>
        <thead><tr><th>Object</th><th>MTID</th><th>G_BP-G_RP</th><th>M_G</th></tr></thead>
        <tbody>${tableRows}</tbody>
      </table>
    `).attr("hidden", false);
  }

  setAssociationCmdStatus(text, mode) {
    const status = $("#moca-cmd-status");
    status.text(text);
    status.toggleClass("loading", mode == "loading");
    status.toggleClass("error", mode == "error");
  }

  setAssociationCmdLoading(visible) {
    $("#moca-cmd-loader").toggleClass("is-visible", Boolean(visible));
  }

  renderAssociationCmdDatavizLink(mocaAid) {
    const wrapper = $("#moca-cmd-wrapper");
    const target = $("#moca-cmd-dataviz");
    if (wrapper.length == 0 || target.length == 0) return;
    const url = this.associationCmdDatavizUrl(mocaAid);
    target.html(`For a richer exploration of the Gaia CMD, use the <a href="${this.escapeHtml(url)}" target="_blank" rel="noopener">Gaia CMD explorer</a>.`).attr("hidden", false);
  }

  associationCmdDatavizUrl(mocaAid) {
    const base = $("#moca-cmd-wrapper").attr("data-dataviz-url") || "https://dataviz.mocadb.ca/js/gaia-cmd";
    try {
      const url = new URL(base, window.location.href);
      url.searchParams.set("moca_aid", mocaAid);
      return url.toString();
    } catch (error) {
      const separator = base.indexOf("?") == -1 ? "?" : "&";
      return `${base}${separator}moca_aid=${encodeURIComponent(mocaAid)}`;
    }
  }

  compactSql(query) {
    return String(query || "").trim().replace(/\s+/g, " ");
  }

  numericOrNull(value) {
    if (value === null || value === undefined || value === "") return null;
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  escapeHtml(value) {
    return String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  takeSearchPrefetch(searchType, searchQuery) {
    const prefetch = window.mocaSearchPrefetch;
    if (!prefetch || prefetch.consumed) return null;
    if (String(prefetch.searchType) != String(searchType)) return null;
    if (String(prefetch.searchQuery) != String(searchQuery)) return null;

    prefetch.consumed = true;
    return prefetch.promise;
  }

  prepareApiRequest(wrapperSelector) {
    $(".results .error-message", wrapperSelector).remove();
    $(".loader", wrapperSelector).addClass("loading");
  }

  completeApiRequest(data, wrapperSelector, buildCallback) {
    $(".loader", wrapperSelector).removeClass("loading");
    buildCallback.call(this, data, $(".results", wrapperSelector));
    this.anim.attach();
    this.anim.resize();
    return data;
  }

  failApiRequest(error, wrapperSelector, buildCallback) {
    const responseText = String(error?.responseText || error?.message || "The request could not be completed.");
    const errorMessage = $("<div class='error-message'></div>")
      .append("<span class='error-label'>Error</span>")
      .append($("<p></p>").text(responseText));

    buildCallback.call(this, [], $(".results", wrapperSelector));
    $(".results", wrapperSelector).prepend(errorMessage);
    $(".loader", wrapperSelector).removeClass("loading");
    return undefined;
  }

  prefetchedApiRequest(prefetchedRequest, wrapperSelector, buildCallback) {
    this.prepareApiRequest(wrapperSelector);

    return Promise.resolve(prefetchedRequest)
      .then((result) => {
        if (!result || result.ok !== true) {
          const error = new Error(result?.error || "The prefetched report request failed.");
          error.responseText = result?.error;
          throw error;
        }
        return this.completeApiRequest(result.data, wrapperSelector, buildCallback);
      })
      .catch((error) => {
        console.log("Error : ", error);
        return this.failApiRequest(error, wrapperSelector, buildCallback);
      })
      .finally(() => {
        if (window.mocaSearchPrefetch?.promise === prefetchedRequest) {
          window.mocaSearchPrefetch = null;
        }
      });
  }

  apiRequest(url, wrapperSelector, buildCallback, data = {}, method = "post") {
    return new Promise((resolve) => {
      this.prepareApiRequest(wrapperSelector);

      $.ajax({
        dataType: "json",
        method: method,
        url: url,
        data: data,
        success: $.proxy(function (data) {
          resolve(this.completeApiRequest(data, wrapperSelector, buildCallback));
        }, this),
        error: $.proxy(function (error) {
          console.log("Error : ", error);
          resolve(this.failApiRequest(error, wrapperSelector, buildCallback));
        }, this),
      });
    })
  }

  buildQueryResultsTable(data, destination) {

    if (table) {
      table.clear()
      table.destroy()
      table = null
    }

    if (data.length == 0) {
      $("#results-table-wrapper").html("<p class='no-result'>No data rows were returned.</p>");
      $("#results-table-wrapper").css("opacity", 1);
      return;
    }

    $("#results-table-wrapper").html("<table id=\"results-table\"></table>");

    var columns = [];
    if (data[0]) {
      $(Object.keys(data[0])).each(function (i, key) {
        columns.push({
          "title": key,
          "data": key,
          render: function (data, type, row) {
            return '<div class="td-content">' + data + "</div>";
          }
        })
      });
    }

    table = new DataTable("#results-table", {
      data: data,
      columns: columns,
      scrollX: true,
      searching: false,
      ordering: false,
      // paging: false,
      pageLength: 200,
      lengthChange: false,
      // dom: 'Bfrtip',
      dom: 'Bfiprtip',
      buttons: [
        'copy',
        // 'csv',
        // 'excel',
        // 'pdf',
        // 'print',
        'csvHtml5',
      ],
    });
    $("#results-table-wrapper").css("opacity", 1);
  }

  buildPublicationReport(data, destination) {
    destination.children(":not(.loader)").remove();

    if (data?.error) {
      destination.append(
        $("<div class='error-message'></div>")
          .append("<span class='error-label'>Error</span>")
          .append($("<p></p>").text(data.error))
      );
      return;
    }

    if (data?.chooser) {
      this.buildPublicationChooser(data, destination);
      return;
    }

    const mocaPid = String(data?.mocaPid || "");
    const publicationRows = Array.isArray(data?.publicationRows) ? data.publicationRows : [];
    const tables = Array.isArray(data?.tables) ? data.tables : [];
    const listedTablesWithRows = tables.filter((tableInfo) => {
      return Number(tableInfo.rowCount) > 0 && tableInfo.tableName != "moca_publications";
    });
    const totalRows = Number(data?.totalRows || 0);

    const summary = $("<div class='publication-report-summary'></div>");
    summary.append($("<span></span>").text(`moca_pid: ${mocaPid}`));
    summary.append($("<span></span>").text(`${listedTablesWithRows.length} listed tables with rows`));
    summary.append($("<span></span>").text(`${tables.length} visible moca_pid tables checked`));
    summary.append($("<span></span>").text(`${totalRows} total matching rows`));
    destination.append(summary);

    if (publicationRows.length > 0) {
      const publicationEntry = $("<div class='box publication-entry'></div>");
      publicationEntry.append("<h3>moca_publications entry</h3>");
      publicationEntry.append(this.buildPublicationEntryDetails(publicationRows[0]));
      destination.append(publicationEntry);
    } else {
      destination.append($("<p class='publication-report-empty'></p>").text("No matching row was found in moca_publications for the current connection."));
    }

    const list = $("<div class='publication-table-list'></div>");
    listedTablesWithRows.forEach((tableInfo) => {
      list.append(this.buildPublicationTableCard(mocaPid, tableInfo));
    });

    destination.append(list);
  }

  buildPublicationChooser(data, destination) {
    const query = String(data?.query || data?.mocaPid || "");
    const matches = Array.isArray(data?.matches) ? data.matches : [];
    const chooser = $("<div class='box publication-chooser'></div>");
    const list = $("<div class='publication-match-list'></div>");

    chooser.append($("<h3></h3>").text(`Multiple publications match "${query}"`));
    chooser.append($("<p></p>").text("Select a moca_pid below to open the corresponding publication report."));

    matches.forEach((match) => {
      const mocaPid = String(match?.moca_pid || "").trim();
      const href = `/publication/results?moca-pid=${encodeURIComponent(mocaPid)}`;
      const item = $("<a class='publication-match' aria-label='Open publication report'></a>")
        .attr("href", href);
      const title = $("<span class='publication-match-title'></span>").text(mocaPid);
      const meta = $("<span class='publication-match-meta'></span>");
      const details = [
        match?.name,
        match?.bibcode,
        match?.journal,
        match?.year,
      ].filter((value) => value !== null && value !== undefined && String(value).trim() != "");

      meta.text(details.join(" | "));
      item.append(title);
      if (details.length > 0) item.append(meta);

      if (match?.description) {
        item.append($("<span class='publication-match-description'></span>").text(String(match.description)));
      }

      list.append(item);
    });

    chooser.append(list);
    destination.append(chooser);
  }

  buildPublicationEntryDetails(row) {
    const details = $("<dl class='publication-entry-details'></dl>");

    Object.keys(row || {}).forEach((key) => {
      details.append($("<dt></dt>").text(key));
      details.append($("<dd></dd>").html(this.publicationCellHtml(row[key])));
    });

    return details;
  }

  buildPublicationTableCard(mocaPid, tableInfo) {
    const tableName = String(tableInfo?.tableName || "");
    const tableType = String(tableInfo?.tableType || "");
    const rowCount = Number.isFinite(tableInfo?.rowCount) ? tableInfo.rowCount : null;
    const hasError = Boolean(tableInfo?.error);
    const card = $("<div class='box publication-table-card'></div>");
    const header = $("<div class='publication-table-header'></div>");
    const panelId = `publication-table-panel-${tableName.replace(/[^A-Za-z0-9_-]/g, "-")}`;
    const csvUrl = `/api/publication-report/table.csv?moca-pid=${encodeURIComponent(mocaPid)}&table=${encodeURIComponent(tableName)}`;
    const button = $("<button class='publication-table-toggle' type='button'></button>")
      .attr("aria-expanded", "false")
      .attr("aria-controls", panelId)
      .prop("disabled", hasError)
      .append($("<span class='publication-table-name'></span>").text(tableName))
      .append($("<span class='publication-table-type'></span>").text(tableType))
      .append($("<span class='publication-table-count'></span>").text(hasError ? "count failed" : `${rowCount} rows`));
    const downloadLink = $("<a class='button publication-table-download'></a>")
      .attr("href", csvUrl)
      .text("Download as CSV");
    const panel = $("<div class='publication-table-panel' hidden></div>")
      .attr("id", panelId)
      .attr("data-table-name", tableName)
      .attr("data-loaded-rows", "0")
      .attr("data-row-count", rowCount == null ? "0" : String(rowCount));

    if (hasError) {
      panel.append($("<p class='publication-table-status'></p>").text(tableInfo.error));
    } else if (rowCount == 0) {
      panel.append($("<p class='publication-table-status'></p>").text("No rows in this table match this moca_pid."));
    } else {
      panel.append($("<p class='publication-table-status'></p>").text("Rows are loaded when this table is expanded."));
      panel.append("<div class='publication-table-wrap'></div>");
      panel.append($("<button class='publication-load-more' type='button'>Load more rows</button>").prop("hidden", true));
    }

    button.on("click", () => {
      const isOpen = button.attr("aria-expanded") == "true";
      button.attr("aria-expanded", isOpen ? "false" : "true");
      panel.prop("hidden", isOpen);

      if (!isOpen && rowCount > 0 && panel.attr("data-loaded") != "1") {
        this.loadPublicationTableRows(mocaPid, tableName, panel, true);
      }
    });

    $(".publication-load-more", panel).on("click", () => {
      this.loadPublicationTableRows(mocaPid, tableName, panel, false);
    });

    header.append(button);
    if (!hasError && rowCount > 0) {
      header.append(downloadLink);
    }

    card.append(header);
    card.append(panel);
    return card;
  }

  loadPublicationTableRows(mocaPid, tableName, panel, reset) {
    const limit = reset ? 10 : 200;
    const offset = reset ? 0 : Number(panel.attr("data-loaded-rows") || 0);
    const status = $(".publication-table-status", panel);
    const loadMoreButton = $(".publication-load-more", panel);

    loadMoreButton.prop("disabled", true);
    status.text(reset ? "Loading rows..." : "Loading more rows...");

    $.ajax({
      dataType: "json",
      method: "get",
      url: "/api/publication-report/table",
      data: {
        "moca-pid": mocaPid,
        "table": tableName,
        "offset": offset,
        "limit": limit,
      },
      success: (data) => {
        if (data?.error) {
          status.text(data.error);
          return;
        }

        const rows = Array.isArray(data?.rows) ? data.rows : [];
        const columns = Array.isArray(data?.columns) ? data.columns : [];
        const rowCount = Number(data?.rowCount || 0);
        const loadedRows = offset + rows.length;

        if (reset) {
          $(".publication-table-wrap", panel).empty().append(this.buildPublicationRowsTable(rows, columns));
        } else {
          this.appendPublicationRows($(".publication-data-table tbody", panel), rows, columns);
        }

        panel.attr("data-loaded", "1");
        panel.attr("data-loaded-rows", String(loadedRows));
        status.text(`Showing ${Math.min(loadedRows, rowCount)} of ${rowCount} rows.`);
        loadMoreButton.prop("hidden", loadedRows >= rowCount).prop("disabled", false);
      },
      error: (error) => {
        status.text(error.responseJSON?.error || error.responseText || "Could not load rows.");
        loadMoreButton.prop("disabled", false);
      },
    });
  }

  buildPublicationRowsTable(rows, columns = null) {
    const safeRows = Array.isArray(rows) ? rows : [];
    const safeColumns = Array.isArray(columns) && columns.length > 0
      ? columns
      : (safeRows.length > 0 ? Object.keys(safeRows[0]) : []);

    if (safeColumns.length == 0) {
      return $("<p></p>").text("No rows to display.");
    }

    const table = $("<table class='publication-data-table'></table>");
    const thead = $("<thead></thead>");
    const tbody = $("<tbody></tbody>");
    const headerRow = $("<tr></tr>");

    safeColumns.forEach((column) => {
      headerRow.append($("<th></th>").text(column));
    });
    thead.append(headerRow);
    table.append(thead);
    table.append(tbody);

    this.appendPublicationRows(tbody, safeRows, safeColumns);
    return table;
  }

  appendPublicationRows(tbody, rows, columns) {
    const safeRows = Array.isArray(rows) ? rows : [];
    const safeColumns = Array.isArray(columns) ? columns : [];

    safeRows.forEach((row) => {
      const tr = $("<tr></tr>");
      safeColumns.forEach((column) => {
        tr.append($("<td></td>").html(this.publicationCellHtml(row?.[column])));
      });
      tbody.append(tr);
    });
  }

  publicationCellHtml(value) {
    if (value === null || value === undefined) return "<span class='publication-null'>NULL</span>";
    if (typeof value == "object") return this.escapeHtml(JSON.stringify(value));
    return this.escapeHtml(value);
  }

  reportSectionId(title, index) {
    const slug = String(title || "section")
      .toLowerCase()
      .replace(/&[a-z0-9#]+;/gi, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

    return `report-section-${index + 1}-${slug || "section"}`;
  }

  isReportSectionCollapsible(title, reportType) {
    const key = this.reportSectionKey(title);

    if (/^all\b/i.test(String(title || "").trim())) return true;

    return reportType == "association" && [
      "relevant references",
      "first 500 members",
      "overlap in memberships",
    ].indexOf(key) != -1;
  }

  reportSectionKey(title) {
    return String(title || "")
      .replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  reportCollaboratorMessage() {
    return "YOU ARE CURRENTLY LOGGED IN AS A MOCADB COLLABORATOR";
  }

  reportTitleParts(title) {
    const collaboratorMessage = this.reportCollaboratorMessage();
    const titleText = stringValues(title);
    const titleKey = this.reportSectionKey(titleText);
    const collaboratorKey = this.reportSectionKey(collaboratorMessage);

    if (!titleKey.includes(collaboratorKey)) {
      return {
        title: titleText,
        notice: "",
        collaborator: false,
      };
    }

    const titleWithoutNotice = titleText
      .replace(new RegExp(collaboratorMessage.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i"), "")
      .replace(/^(<br\s*\/?>|\s|&nbsp;)+/i, "")
      .replace(/(<br\s*\/?>|\s|&nbsp;)+$/i, "")
      .trim();

    return {
      title: titleWithoutNotice || titleText,
      notice: collaboratorMessage,
      collaborator: true,
    };
  }

  reportSectionDisplayTitle(title, reportType) {
    const key = this.reportSectionKey(title);

    if (key == "summary table") {
      return "SUMMARY";
    }

    if (key == "catalog designations") {
      return "ALL CATALOG DESIGNATIONS";
    }

    if (reportType == "association" && key == "members") {
      return "MEMBER SUMMARY";
    }

    return stringValues(title);
  }

  reportSectionIntro(title) {
    const key = this.reportSectionKey(title);
    const normalizedKey = key.replace(/σ/g, "sigma");

    if (!/^all\b/.test(normalizedKey) || !normalizedKey.includes("banyan") || !normalizedKey.includes("sigma")) return null;

    return $("<div class='report-section-intro'></div>")
      .append(
        $("<p></p>").html(
          'Please see <a href="https://ui.adsabs.harvard.edu/abs/2018ApJ...856...23G/abstract" target="_blank" rel="noopener">Gagné et al. (2018)</a> for the details of the BANYAN Sigma classifier and <a href="https://ui.adsabs.harvard.edu/abs/2026arXiv260215695G/abstract" target="_blank" rel="noopener">Gagné et al. 2026</a> for the updated BANYAN Sigma models, and please acknowledge both papers when you use results from this tool.'
        )
      )
      .append(
        $("<p></p>").html(
          'This section of the report shows the BANYAN Sigma results for each flavor of the BANYAN Sigma models, and for each possible combination of observables for this star: <code>pm</code> is the minimum set of observables (equatorial coordinates and proper motion); <code>rv</code> is the radial velocity and <code>plx</code> is the parallax (or photometric distance). The <strong>Probability</strong> result is the total membership probability for all possible young associations combined, in %. Most of the time, this is concentrated in a single association, but for some ambiguous members it can be distributed across more than one. When this happens, the <strong>All Plausible Memberships</strong> section will contain more than one <code>moca_aid</code> key with its relative share of the total association probability, in %. For example, All plausible memberships: BPMG(60); ABDMG(40), with Probability: 90% would mean that the total association probability (90%) is divided 60/40 between BPMG and ABDMG. In other words, the absolute BPMG probability is 0.6 x 90% = 54%, and the ABDMG probability is 0.4 x 90% = 36%. The priors of BANYAN Sigma are adjusted such that a selection threshold of 90% in total association probability will recover 90% of the true members across associations, when using input measurements with a precision similar to Gaia (see Section 6 of <a href="https://ui.adsabs.harvard.edu/abs/2018ApJ...856...23G/abstract" target="_blank" rel="noopener">Gagné et al. (2018)</a>). The contamination rate even at a 90% probability threshold varies widely between different associations and is usually worse for the nearest associations or those with larger UVW models. When choosing a different threshold than 90%, the recovery rate also becomes association-dependent.'
        )
      );
  }

  reorderReportTables(tables, reportType) {
    const sectionOrderBeforeSpectralTypes = [
      "kinematics",
      "gaia dr3 neighborhood",
      "object properties",
      "viewing angle",
      "coordinates",
      "gaia dr3 further information",
    ];
    const movedSections = [];
    const remainingSections = [];

    tables.forEach((table, index) => {
      const key = this.reportSectionKey(table.title);
      const moveIndex = sectionOrderBeforeSpectralTypes.indexOf(key);

      if (key != "all spectral types" && moveIndex != -1) {
        movedSections.push({table: table, order: moveIndex, originalIndex: index});
      } else {
        remainingSections.push(table);
      }
    });

    const spectralTypesIndex = remainingSections.findIndex((table) => {
      return this.reportSectionKey(table.title) == "all spectral types";
    });

    if (spectralTypesIndex == -1 || movedSections.length == 0) {
      return this.reorderAssociationReportTables(tables, reportType);
    }

    movedSections.sort((a, b) => {
      if (a.order == b.order) return a.originalIndex - b.originalIndex;
      return a.order - b.order;
    });

    remainingSections.splice(spectralTypesIndex, 0, ...movedSections.map((section) => section.table));
    return this.reorderAssociationReportTables(remainingSections, reportType);
  }

  reorderAssociationReportTables(tables, reportType) {
    if (reportType != "association") return tables;

    const memberSummaryIndex = tables.findIndex((table) => {
      return this.reportSectionKey(table.title) == "member summary";
    });
    const observablePropertiesIndex = tables.findIndex((table) => {
      return this.reportSectionKey(table.title) == "observable properties";
    });

    if (memberSummaryIndex == -1 || observablePropertiesIndex == -1) {
      return tables;
    }

    const reorderedTables = tables.slice();
    const memberSummary = reorderedTables.splice(memberSummaryIndex, 1)[0];
    const insertIndex = reorderedTables.findIndex((table) => {
      return this.reportSectionKey(table.title) == "observable properties";
    }) + 1;

    reorderedTables.splice(insertIndex, 0, memberSummary);
    return reorderedTables;
  }

  normalizeReportTables(data, reportType) {
    const tables = Array.isArray(data) ? data : [];

    return this.reorderReportTables(tables
      .filter((table) => table != null)
      .map((table) => {
        const titleParts = this.reportTitleParts(table.title);
        return {
          ...table,
          title: this.reportSectionDisplayTitle(titleParts.title, reportType),
          reportNotice: titleParts.notice,
          isCollaboratorReport: titleParts.collaborator,
        };
      }), reportType);
  }

  isCollaboratorReport(tables) {
    return (Array.isArray(tables) ? tables : []).some((table) => {
      return table?.isCollaboratorReport || table?.reportNotice == this.reportCollaboratorMessage();
    });
  }

  reportTextForDetection(value) {
    return String(value || "")
      .replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  isReportChooser(tables) {
    return (Array.isArray(tables) ? tables : []).some((table) => {
      const tableText = this.reportTextForDetection(table?.title);
      const hasChooserTitle = tableText.includes("multiple objects were found")
        || tableText.includes("multiple associations were found");

      if (hasChooserTitle) return true;

      return (Array.isArray(table?.data) ? table.data : []).some((row) => {
        const rowText = [
          row?.label,
          row?.value,
          row?.refs,
          row?.bibcodes,
          row?.comment,
        ].map((value) => this.reportTextForDetection(value)).join(" ");

        return rowText.includes("multiple objects were found")
          || rowText.includes("multiple associations were found");
      });
    });
  }

  setReportSidePaneVisible(destination, visible) {
    const row = $(destination).closest(".report-scroll-row");
    row.toggleClass("report-single-column", !visible);
    $(".report-side-pane", row).prop("hidden", !visible);
  }

  setReportCollaboratorState(destination, isCollaboratorReport) {
    $(destination).closest(".report-scroll-row").toggleClass("report-collaborator", isCollaboratorReport);
  }

  bindReportCollapseControls(destination) {
    $(".report-collapse-toggle", destination).off("click").on("click", $.proxy(function (event) {
      event.preventDefault();
      const sectionId = $(event.currentTarget).closest(".report-section").attr("id");
      this.toggleReportSection(sectionId);
    }, this));
  }

  buildReportSearchControls(destination, sections) {
    const titleActions = $("#report-title-actions");
    $(".report-search-actions", destination).remove();
    titleActions.empty();

    const collapsibleSections = (Array.isArray(sections) ? sections : []).filter((section) => {
      return section.collapsible;
    });

    if (collapsibleSections.length == 0) return;

    const actions = $("<div class='report-search-actions'></div>");
    const expandAllButton = $("<button class='report-expand-all-button' type='button'></button>")
      .text("Expand all sections")
      .attr("title", "Useful for control+F searches");
    const collapseAllButton = $("<button class='report-collapse-all-button' type='button'></button>")
      .text("Collapse all sections");

    expandAllButton.on("click", $.proxy(function (event) {
      event.preventDefault();
      collapsibleSections.forEach((section) => {
        this.setReportSectionExpanded(section.id, true);
      });
    }, this));

    collapseAllButton.on("click", $.proxy(function (event) {
      event.preventDefault();
      collapsibleSections.forEach((section) => {
        this.setReportSectionExpanded(section.id, false);
      });
    }, this));

    actions.append(expandAllButton);
    actions.append(collapseAllButton);

    if (titleActions.length > 0) {
      titleActions.append(actions);
    } else {
      $(destination).prepend(actions);
    }
  }

  toggleReportSection(sectionId) {
    const section = $("#" + sectionId);
    if (section.length == 0 || !section.hasClass("report-section-collapsible")) return;

    this.setReportSectionExpanded(sectionId, section.hasClass("is-collapsed"));
  }

  setReportSectionExpanded(sectionId, expanded) {
    const section = $("#" + sectionId);
    if (section.length == 0 || !section.hasClass("report-section-collapsible")) return;

    const title = section.data("report-title") || "section";
    section.toggleClass("is-collapsed", !expanded);
    section.toggleClass("is-expanded", expanded);
    section.find("> .report-section-title .report-collapse-toggle")
      .attr("aria-expanded", expanded ? "true" : "false")
      .attr("aria-label", `${expanded ? "Collapse" : "Expand"} ${title}`);
  }

  scrollToReportSection(sectionId) {
    const target = document.getElementById(sectionId);
    if (!target) return;

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const behavior = reducedMotion ? "auto" : "smooth";
    const pane = target.closest(".report-scroll-pane");

    if (pane && window.getComputedStyle(pane).overflowY != "visible") {
      const paneRect = pane.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      pane.scrollTo({
        top: pane.scrollTop + targetRect.top - paneRect.top - 8,
        behavior: behavior,
      });
      return;
    }

    target.scrollIntoView({behavior: behavior, block: "start"});
  }

  buildReportTableOfContents(sections) {
    const wrapper = $("#report-toc-wrapper");
    const toc = $("#report-toc");

    if (wrapper.length == 0 || toc.length == 0) return;

    toc.empty();

    if (!Array.isArray(sections) || sections.length == 0) {
      wrapper.prop("hidden", true);
      return;
    }

    const list = $("<ol class='report-toc-list'></ol>");
    sections.forEach((section) => {
      const link = $("<a class='report-toc-link'></a>")
        .attr("href", "#" + section.id)
        .attr("data-report-section-id", section.id);

      link.append($("<span class='report-toc-label'></span>").text(section.title));
      link.append($("<span class='report-toc-count'></span>").text(`(${section.count})`));
      list.append($("<li></li>").append(link));
    });

    toc.append(list);
    wrapper.prop("hidden", false);

    $(".report-toc-link", toc).on("click", $.proxy(function (event) {
      event.preventDefault();
      const sectionId = $(event.currentTarget).data("report-section-id");
      this.setReportSectionExpanded(sectionId, true);
      this.scrollToReportSection(sectionId);

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, "", `${window.location.pathname}${window.location.search}#${sectionId}`);
      }
    }, this));

    const hashSectionId = window.location.hash.slice(1);
    if (hashSectionId && sections.some((section) => section.id == hashSectionId)) {
      this.setReportSectionExpanded(hashSectionId, true);
      window.setTimeout(() => {
        this.scrollToReportSection(hashSectionId);
      }, 0);
    }
  }

  buildResultsPage(data, destination) {
    const isReportPage = $(destination).closest("#search-results-wrapper").length > 0;
    const reportType = isReportPage ? String($(destination).data("type") || "") : "";
    const tables = isReportPage ? this.normalizeReportTables(data, reportType) : data;
    const isChooserReport = isReportPage && this.isReportChooser(tables);
    const isCollaboratorReport = isReportPage && this.isCollaboratorReport(tables);
    const reportSections = [];

    $(destination).children(".box, .report-search-actions").remove();
    $("#report-title-actions").empty();

    if (isReportPage) {
      this.buildReportTableOfContents([]);
      this.setReportSidePaneVisible(destination, !isChooserReport);
      this.setReportCollaboratorState(destination, isCollaboratorReport);
    }

    $(tables).each((i, table) => {

      // Skip empty table
      if (table == null) {
        return;
      }

      const title = stringValues(table.title);
      const rows = Array.isArray(table.data) ? table.data : [];
      const sectionId = isReportPage ? this.reportSectionId(title, i) : null;
      const isCollapsible = isReportPage && this.isReportSectionCollapsible(title, reportType);
      var box = $("<div class='box'></div>")
      var fieldContainer = box;

      if (!isReportPage) {
        box.addClass("in-view")
          .attr("data-animation", "fadeInUp")
          .attr("data-animation-delay", "0.1s")
          .attr("data-animation-duration", "1.7s");
      }

      if (isReportPage && !isChooserReport) {
        const bodyId = sectionId + "-body";
        const sectionTitle = $("<h3 class='report-section-title'></h3>");
        const sectionBody = $("<div class='report-section-body'></div>").attr("id", bodyId);

        box.addClass("report-section")
          .attr("id", sectionId)
          .attr("data-report-title", title);

        if (isCollapsible) {
          box.addClass("report-section-collapsible is-collapsed");
          sectionTitle.append(
            $("<button class='report-collapse-toggle' type='button'><span class='report-collapse-icon' aria-hidden='true'></span></button>")
              .attr("aria-expanded", "false")
              .attr("aria-controls", bodyId)
              .attr("aria-label", "Expand " + title)
          );
        }

        if (table.reportNotice) {
          box.append($("<div class='report-section-notice'></div>").text(table.reportNotice));
        }

        sectionTitle.append($("<span class='report-section-title-text'></span>").text(title));
        box.append(sectionTitle);
        box.append(sectionBody);
        fieldContainer = sectionBody;
        const sectionIntro = this.reportSectionIntro(title);
        if (sectionIntro) {
          fieldContainer.append(sectionIntro);
        }
        reportSections.push({
          id: sectionId,
          title: title,
          count: rows.length,
          collapsible: isCollapsible,
        });
      } else {
        box.append("<h3>" + title + "</h3>")
      }

      $(rows).each(function (i, row) {
        var field = $("<div class='field'></div>")
        field.append("<div class='field-name'>" + stringValues(row.label) + "</div>");
        if (table.wrapLabelInLink) {
          var link = window.location.pathname + "/" + field.find(".field-name").text()
          field.find(".field-name").wrapInner("<a href=" + link + "/>")
        }
        field.append("<div class='field-values'></div>")

        // Add row value
        if (!isEmptyBufferObject(row.value)) {
          field.find(".field-values").append("<div class='field-main-value'>" + stringValues(row.value) + "</div>")
        }

        // Add REPORT/AREPORT additional fields
        $(['refs', 'bibcodes', 'comment']).each(function (j, additionalField) {
          if (!isEmptyBufferObject(row[additionalField])) {
            field.find(".field-values").append("<div class='field-" + additionalField + "-value'>" + stringValues(row[additionalField]) + "</div>")
          }
        })

        // Add Associations additional fields
        $(['discovery_bibcode', 'is_real', 'coeval', 'parent_structure', 'relationships', 'physical_nature', 'bibcodes_with_membership', 'bibcodes_with_ages', 'comments']).each(function (j, additionalField) {
          if (!isEmptyBufferObject(row[additionalField])) {
            field.find(".field-values").append("<div class='field-" + additionalField + "-value'>" + stringValues(row[additionalField]) + "</div>")
          }
        })

        fieldContainer.append(field)
      })

      $(destination).append(box)
    })

    if (isReportPage && !isChooserReport) {
      this.buildReportSearchControls(destination, reportSections);
      this.buildReportTableOfContents(reportSections);
      this.bindReportCollapseControls(destination);
      this.resize();
    }
  }
}


function stringValues(string) {
  return (string != undefined && string != null) ? string : "";
}

function isEmptyBufferObject(object) {
  return (object != null && typeof object === "object" && object.type === "Buffer" && object.data.length <= 0);
}
